var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlaceholder(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 329.828,
    height: 281.299,
    viewBox: "0 0 329.828 281.299",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Firmware-amico",
    transform: "translate(-14.41 -62.949)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-209",
    transform: "translate(14.41 151.67)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--floor--inject-209-2",
    "data-name": "freepik--floor--inject-209"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--floor--inject-209-3",
    "data-name": "freepik--floor--inject-209",
    cx: 164.914,
    cy: 95.208,
    rx: 164.914,
    ry: 95.208,
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Lines--inject-209",
    transform: "translate(0.035 3.163)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63444",
    "data-name": "Group 63444",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_67336",
    "data-name": "Path 67336",
    d: "M56.349,265.175H44.937l-4.37-2.525-.477.54,4.657,2.686H56.159l19.864,11.468.351-.61-19.941-11.51Z",
    transform: "translate(-22.113 -214.464)",
    fill: "#102633"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67337",
    "data-name": "Path 67337",
    d: "M73.17,312.024l97.523,56.309.077.049h17.283l38.388-22.164-.351-.61L187.87,367.68H170.96L73.871,311.624v-9.469l13.755-8.312-.365-.6L73.17,301.755Z",
    transform: "translate(-31.991 -223.598)",
    fill: "#102633"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67338",
    "data-name": "Path 67338",
    d: "M310.75,388.93,273.576,410.4a3.24,3.24,0,0,0-2.476.175.877.877,0,0,0,0,1.655,3.149,3.149,0,0,0,2.876,0c.7-.386.764-.975.3-1.4l36.831-21.267Z",
    transform: "translate(-90.916 -252.17)",
    fill: "#102633"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67339",
    "data-name": "Path 67339",
    d: "M336.562,274.854a.877.877,0,0,0,0,1.662,3.177,3.177,0,0,0,2.869,0,.877.877,0,0,0,0-1.662,2.806,2.806,0,0,0-1.08-.323V268.92l-22.8-13.165v-9.883l-33.667-19.443-.084-.049H270.3v.7h11.307l33.247,19.2V292.34l10.163,5.864.351-.6-3.767-2.174,2.5-1.445v-8.915a2.708,2.708,0,0,0,1.087-.33.877.877,0,0,0,0-1.655,3.177,3.177,0,0,0-2.869,0,.877.877,0,0,0,0,1.655,2.707,2.707,0,0,0,1.08.33v8.508l-2.5,1.445-5.345-3.086V264.95l14.856,8.592v5.225a2.665,2.665,0,0,0-1.08.323.877.877,0,0,0,0,1.655,3.156,3.156,0,0,0,2.869,0,.877.877,0,0,0,0-1.662,2.8,2.8,0,0,0-1.087-.323V273.15l-15.585-9v-7.6l22.094,12.751v5.2A2.8,2.8,0,0,0,336.562,274.854Z",
    transform: "translate(-90.853 -203.634)",
    fill: "#102633"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67340",
    "data-name": "Path 67340",
    d: "M291.664,338.138l-13-7.505H255.872L233.841,317.91l-.351.61,22.192,12.815h22.8l12.836,7.407Z",
    transform: "translate(-79.862 -230.964)",
    fill: "#102633"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67341",
    "data-name": "Path 67341",
    d: "M237.78,339.131l-7.344-4.208H127.729L91.761,314.091v-9.5l8.375-4.847-.351-.61-8.725,5.036v10.3L127.533,335.6h11.461l25.636,14.729.084.049h17.107l12.59,7.267c-.463.456-.365,1.045.3,1.4a3.191,3.191,0,0,0,2.876,0,.877.877,0,0,0,0-1.655,3.177,3.177,0,0,0-2.476-.175l-13.1-7.568H164.9L140.4,335.54H161.86l14.245,8.22H193.2l6.909,3.984c-.463.456-.372,1.045.3,1.4a3.177,3.177,0,0,0,2.869,0,.877.877,0,0,0,0-1.655,3.163,3.163,0,0,0-2.469-.175l-7.386-4.2H176.3L163.262,335.6h66.984l7.182,4.138Z",
    transform: "translate(-37.333 -225.356)",
    fill: "#102633"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67342",
    "data-name": "Path 67342",
    d: "M275.914,356.8H256.857a1.284,1.284,0,0,0-.491-.477,3.17,3.17,0,0,0-2.876,0,.877.877,0,0,0,0,1.655,3.149,3.149,0,0,0,2.876,0,1.235,1.235,0,0,0,.491-.477h18.868l4.349,2.511.351-.6Z",
    transform: "translate(-85.658 -242.331)",
    fill: "#102633"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67343",
    "data-name": "Path 67343",
    d: "M249.521,337.936l-10.17-5.871H142.48l-30.4-17.549v-6.179l2.672-1.543-.351-.6-3.023,1.746v6.979l30.834,17.8.084.049h96.864l10.009,5.78Z",
    transform: "translate(-43.4 -227.465)",
    fill: "#102633"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67344",
    "data-name": "Path 67344",
    d: "M454.358,305.371c-.056-.231-.126-.463-.189-.7L424.6,321.735H407.511l-18.6,10.738.351.61,18.433-10.647h17.1Z",
    transform: "translate(-126.27 -227.011)",
    fill: "#102633"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67345",
    "data-name": "Path 67345",
    d: "M14.46,315.318v.814L39.711,330.7v13.165l93.511,54.008.084.042h17.283l28.575-16.5.175-.1v-9.89L217.5,349.4l-.351-.61-38.332,22.136-.175.1v9.869l-8.2,4.734-70.2-40.527h0L46.107,313.845V297.8l16.918-9.771-.351-.6L45.581,297.3l-.175.1v16.834L56.8,320.81v9.1l-27.79-16.069V297.4L19,291.617c-.042.091-.077.189-.112.281s-.105.253-.154.379l9.574,5.527v16.448L56.8,330.7v16.455l29.957,17.29c-.463.449-.372,1.038.3,1.4a3.177,3.177,0,0,0,2.869,0,.877.877,0,0,0,0-1.662,3.227,3.227,0,0,0-2.469-.175L57.5,346.748v-25.51l19.275,11.124c0,.47-.042,1.312-.049,2.855l-.105,16.8L152.636,395.9l-2.244,1.291h-16.9L40.4,343.458V330.293Zm85.775,30.6,69.495,40.113-7.849,4.531-61.646-35.6Zm-22.908,5.7c0-1.852.091-15.8.112-18.861l22.094,12.759v9.869l61.646,35.561-7.842,4.531Z",
    transform: "translate(-14.46 -221.863)",
    fill: "#102633"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67346",
    "data-name": "Path 67346",
    d: "M84.745,397.065a3.135,3.135,0,0,0,2.869,0,.877.877,0,0,0,0-1.655,3.24,3.24,0,0,0-2.476-.175L32.392,364.779V351.621l-16.132-9.3.21.933,15.192,8.775v13.158l52.753,30.455C83.973,396.1,84.072,396.679,84.745,397.065Z",
    transform: "translate(-14.997 -238.253)",
    fill: "#102633"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67347",
    "data-name": "Path 67347",
    d: "M45.882,257.08l-.042.042,3.507,2.02H60.724l22.718,13.109.351-.61L61,258.483l-.084-.042h-11.4l-3.163-1.831Z",
    transform: "translate(-23.83 -212.66)",
    fill: "#102633"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67348",
    "data-name": "Path 67348",
    d: "M337.784,426.207V413.049l-13.895-8.024,6.586-3.8-.351-.6-29.908,17.262-.175.1v16.448L287.5,441.673l1.683-.161,11.384-6.572.175-.105V418.422l11.047-6.376,11.047,6.376v9.82l3.647,2.1c-.463.449-.365,1.038.3,1.4a3.149,3.149,0,0,0,2.876,0,.877.877,0,0,0,0-1.655,3.24,3.24,0,0,0-2.476-.175l-3.647-2.1V417.98L312.491,411.6l10.7-6.172,13.895,8.024v13.158l6.207,3.584.891-.3Z",
    transform: "translate(-95.989 -255.661)",
    fill: "#102633"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67349",
    "data-name": "Path 67349",
    d: "M422.177,312.783H405.084l-24.3,14.028.351.6,24.135-13.93h17.1l27.86-16.083-.245-.7Z",
    transform: "translate(-123.842 -224.631)",
    fill: "#102633"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67350",
    "data-name": "Path 67350",
    d: "M419.915,337.715a1.4,1.4,0,0,0-.428.372h-9.56L397,345.529l.351.61,12.737-7.358h9.259a1.172,1.172,0,0,0,.547.589,3.191,3.191,0,0,0,2.876,0,.877.877,0,0,0,0-1.662,3.191,3.191,0,0,0-2.855.007Z",
    transform: "translate(-128.685 -236.776)",
    fill: "#102633"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67351",
    "data-name": "Path 67351",
    d: "M299.713,333.4l-12.976-7.5h-22.8l-22.15-12.787-.351.6,22.312,12.885h22.8l12.815,7.4Z",
    transform: "translate(-82.236 -229.534)",
    fill: "#102633"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67352",
    "data-name": "Path 67352",
    d: "M312.675,207.382v12.352L284.71,203.6l-.084-.049H250.257l-8.627,4.98.351.61,8.466-4.91h34l28.238,16.3v6.579l42.049,24.283v6.579l15.852,9.118c-.617.463-.568,1.122.161,1.55a3.177,3.177,0,0,0,2.869,0,.877.877,0,0,0,0-1.662,3.184,3.184,0,0,0-2.245-.238l-15.936-9.2V250.96l-42.049-24.276V207.747l13.593,7.849h-.049v9.82L394.62,264.5v2.883l-13.993,8.143H363.534l-30,17.318.351.6,29.831-17.219h17.1l14.323-8.277.175-.1V254.306L291.331,194.252l-1.922-.3h0Zm14.947,8.627,66.991,38.682v9.062l-66.991-38.682Z",
    transform: "translate(-82.292 -193.95)",
    fill: "#102633"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67353",
    "data-name": "Path 67353",
    d: "M410.669,238.146c-.463.449-.365,1.038.3,1.4a3.149,3.149,0,0,0,2.876,0,.877.877,0,0,0,0-1.655,3.241,3.241,0,0,0-2.476-.175l-60.959-35.2h0c-.884-.245-1.768-.491-2.651-.7h0Z",
    transform: "translate(-113.982 -196.3)",
    fill: "#102633"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67354",
    "data-name": "Path 67354",
    d: "M302.854,278.1l-.344.61,16.23,9.336v8.508a2.8,2.8,0,0,0-1.08.323.877.877,0,0,0,0,1.662,3.177,3.177,0,0,0,2.869,0,.877.877,0,0,0,0-1.662,2.8,2.8,0,0,0-1.087-.323v-8.915Z",
    transform: "translate(-100.471 -219.077)",
    fill: "#102633"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67355",
    "data-name": "Path 67355",
    d: "M431.356,387.846l-.077-.049h-11.4l-18.44-10.647-.351.61,18.524,10.689.077.049h11.4l3.977,2.294.526-.505Z",
    transform: "translate(-129.907 -248.653)",
    fill: "#102633"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67356",
    "data-name": "Path 67356",
    d: "M433.04,404l-12.408,1.4a1.291,1.291,0,0,0-.477-.449,3.149,3.149,0,0,0-2.876,0,.877.877,0,0,0,0,1.655,3.191,3.191,0,0,0,2.876,0,1.227,1.227,0,0,0,.505-.5l12.085-1.4.659-.533Z",
    transform: "translate(-134.565 -256.67)",
    fill: "#102633"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67357",
    "data-name": "Path 67357",
    d: "M394.128,409.543V396.385l-13-7.505-.351.6,12.625,7.3V409.95l7.224,4.166.7-.386Z",
    transform: "translate(-123.842 -252.156)",
    fill: "#102633"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67358",
    "data-name": "Path 67358",
    d: "M386.008,414.212V401.075l-13-7.505-.351.61,12.625,7.3V414.64l6.86,3.963.765-.372Z",
    transform: "translate(-121.417 -253.556)",
    fill: "#102633"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67359",
    "data-name": "Path 67359",
    d: "M402.294,404.874V391.716l-12.913-7.456-.351.61,12.562,7.245v13.165l7.3,4.208.7-.407Z",
    transform: "translate(-126.305 -250.776)",
    fill: "#102633"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67360",
    "data-name": "Path 67360",
    d: "M439.4,383.107H428L409.571,372.46l-.351.61,18.517,10.689.084.049h11.4l2.483,1.4.491-.526Z",
    transform: "translate(-132.334 -247.253)",
    fill: "#102633"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67361",
    "data-name": "Path 67361",
    d: "M439.289,344.518h-22.8l-7.063,4.208.358.6,6.9-4.138h22.789l22.445-12.976.084-.856Z",
    transform: "translate(-132.397 -234.98)",
    fill: "#102633"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67362",
    "data-name": "Path 67362",
    d: "M447.528,378.467h-11.4l-18.44-10.647-.351.61,18.517,10.689.084.049h11.4l.7.386.449-.547Z",
    transform: "translate(-134.759 -245.867)",
    fill: "#102633"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67363",
    "data-name": "Path 67363",
    d: "M450.246,354.152h-28.5l-4.208,2.609.372.6,4.033-2.5h28.484l11.727-6.769c.1-.33.189-.652.281-.975Z",
    transform: "translate(-134.818 -239.683)",
    fill: "#102633"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67364",
    "data-name": "Path 67364",
    d: "M458.687,370.871H449.12a1.234,1.234,0,0,0-.491-.477,3.177,3.177,0,0,0-2.869,0,.877.877,0,0,0,0,1.655,3.156,3.156,0,0,0,2.869,0,1.249,1.249,0,0,0,.491-.484H458.5l3.023,1.746c.133-.189.267-.386.393-.582Z",
    transform: "translate(-143.069 -246.534)",
    fill: "#102633"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67365",
    "data-name": "Path 67365",
    d: "M323.251,319.825l-9.834-5.674v-6.579l-30.827-17.8-.351.61,30.476,17.6v6.579l10.184,5.878Z",
    transform: "translate(-94.418 -222.562)",
    fill: "#102633"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67366",
    "data-name": "Path 67366",
    d: "M282.7,317.981a1.235,1.235,0,0,0,.491.477,3.17,3.17,0,0,0,2.876,0,.877.877,0,0,0,0-1.662,3.192,3.192,0,0,0-2.876,0,1.284,1.284,0,0,0-.491.477h-9.364L254.151,306.19l-.351.6,19.345,11.187Z",
    transform: "translate(-85.926 -227.465)",
    fill: "#102633"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67367",
    "data-name": "Path 67367",
    d: "M372.182,418.926V402.478l-7.3-4.208-.351.61,6.951,4.012v16.441l8.648,4.994.821-.344Z",
    transform: "translate(-118.99 -254.959)",
    fill: "#102633"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67368",
    "data-name": "Path 67368",
    d: "M315.149,324.529l-9.855-5.688v-6.579l-30.834-17.8-.351.61,30.483,17.6v6.579l10.205,5.892Z",
    transform: "translate(-91.991 -223.962)",
    fill: "#102633"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67369",
    "data-name": "Path 67369",
    d: "M225.37,202.856l.351.61,8.466-4.91h25.4a1.326,1.326,0,0,0,.491.47,3.177,3.177,0,0,0,2.869,0,.877.877,0,0,0,0-1.662,3.177,3.177,0,0,0-2.869,0,1.2,1.2,0,0,0-.5.491H234Z",
    transform: "translate(-77.437 -194.867)",
    fill: "#102633"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67370",
    "data-name": "Path 67370",
    d: "M347.588,291.1v-33.31l-66.507-38.395L281,219.35H258.11v.7h22.7l66.072,38.142v32.5l-14.007,8.1.351.61Z",
    transform: "translate(-87.213 -201.534)",
    fill: "#102633"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67371",
    "data-name": "Path 67371",
    d: "M289.341,430.229l.175-.105V413.676l29.606-17.205-.351-.61-29.957,17.409v16.455L269,441.171l1.529-.077Z",
    transform: "translate(-90.465 -254.24)",
    fill: "#102633"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67372",
    "data-name": "Path 67372",
    d: "M250.129,416.9l.175-.105v-9.869L288.51,384.87l-.351-.61-38.388,22.157-.175.1v9.869L214,436.942l1.206.112Z",
    transform: "translate(-74.042 -250.776)",
    fill: "#102633"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67373",
    "data-name": "Path 67373",
    d: "M240.331,412.159l.175-.105v-9.869l37.967-22.171-.351-.6L239.98,401.68l-.175.1v9.869L200.26,434.477l1.164.14Z",
    transform: "translate(-69.939 -249.328)",
    fill: "#102633"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67374",
    "data-name": "Path 67374",
    d: "M41.52,282.742v18.377a2.806,2.806,0,0,0-1.087.323.877.877,0,0,0,0,1.662,3.177,3.177,0,0,0,2.869,0,.877.877,0,0,0,0-1.662,2.806,2.806,0,0,0-1.08-.323V282.336L30.48,275.56l-.126.182-.274.4Z",
    transform: "translate(-19.124 -218.319)",
    fill: "#102633"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_67375",
    "data-name": "Path 67375",
    d: "M356.158,288.835c0,.645.9,1.171,2.027,1.171s2.034-.526,2.034-1.171-.7-1.059-1.683-1.157v-5.534l-20.116-11.706a.351.351,0,0,0-.351.6l19.766,11.5v5.113C356.915,287.775,356.158,288.252,356.158,288.835Z",
    transform: "translate(-111.045 -216.779)",
    fill: "#102633"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67376",
    "data-name": "Path 67376",
    d: "M336.768,296.546a.351.351,0,0,0-.119.484.344.344,0,0,0,.3.168.33.33,0,0,0,.175-.049l10.093-6.1v-33.26L280.824,219.4l-.077-.049H257.6a.351.351,0,0,0-.351.351.358.358,0,0,0,.351.351h22.936l65.932,38.142v32.454Z",
    transform: "translate(-86.956 -201.534)",
    fill: "#102633"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67377",
    "data-name": "Path 67377",
    d: "M43.9,302.283c0-.582-.7-1.059-1.683-1.157V282.336L30.48,275.56l-.4.582,11.433,6.6v18.377c-.954.1-1.683.575-1.683,1.157s.912,1.171,2.034,1.171S43.9,302.929,43.9,302.283Z",
    transform: "translate(-19.124 -218.319)",
    fill: "#102633"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67378",
    "data-name": "Path 67378",
    d: "M238.731,340.467a.351.351,0,0,0,.344-.61l-8.627-4.91-102.566-.07-36.1-20.846v-9.462l8.368-4.847a.351.351,0,0,0,.126-.477.344.344,0,0,0-.477-.126l-8.7,5.057v10.276l36.529,21.091.084.049h11.412l25.545,14.729.084.049h17.093l12.625,7.274a.842.842,0,0,0-.295.6c0,.645.912,1.171,2.034,1.171s2.034-.526,2.034-1.171-.912-1.178-2.034-1.178a3.183,3.183,0,0,0-1.038.175l-13.109-7.575H164.916l-24.409-14.091,89.78.063Z",
    transform: "translate(-37.344 -225.338)",
    fill: "#102633"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67379",
    "data-name": "Path 67379",
    d: "M170.779,368.355H188.09L226.478,346.2a.365.365,0,0,0,.133-.484.358.358,0,0,0-.484-.126l-38.248,22.066H170.969L73.9,311.618V302.17l13.607-8.347a.351.351,0,0,0,.112-.484.344.344,0,0,0-.477-.112L73.2,301.75v10.276l97.5,56.288Z",
    transform: "translate(-32 -223.578)",
    fill: "#102633"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67380",
    "data-name": "Path 67380",
    d: "M207.582,440.033l40.3-23.266.175-.105v-9.9L286.8,384.4a.351.351,0,1,0-.351-.6l-38.907,22.445-.175.1v9.869L206.46,439.837Z",
    transform: "translate(-71.791 -250.619)",
    fill: "#102633"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67381",
    "data-name": "Path 67381",
    d: "M454.867,305.371c-.063-.2-.119-.491-.189-.7l-29.564,17.065H408.02l-17.233,9.946a.351.351,0,0,0,.175.652.4.4,0,0,0,.175-.042l17.065-9.855h17.1Z",
    transform: "translate(-126.779 -227.011)",
    fill: "#102633"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67382",
    "data-name": "Path 67382",
    d: "M289.716,337.9a.351.351,0,0,0,.3-.175.358.358,0,0,0-.126-.484l-11.222-6.579-.077-.042-22.971-.084L233.766,317.91a.352.352,0,1,0-.351.61l22.017,12.723,22.964.084,11.145,6.537A.386.386,0,0,0,289.716,337.9Z",
    transform: "translate(-79.786 -230.95)",
    fill: "#102633"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67383",
    "data-name": "Path 67383",
    d: "M304.5,319.231l8.718,5.05a.316.316,0,0,0,.175.049.351.351,0,0,0,.175-.652l-8.417-4.847v-6.586l-30.82-17.795a.351.351,0,0,0-.477.126.358.358,0,0,0,.126.484l30.476,17.591Z",
    transform: "translate(-91.902 -223.945)",
    fill: "#102633"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67384",
    "data-name": "Path 67384",
    d: "M229.43,201.225l.351.6,5.611-3.24h25.4a2.2,2.2,0,0,0,1.929.821c1.122,0,2.034-.526,2.034-1.171s-.912-1.171-2.034-1.171a2.2,2.2,0,0,0-1.929.821H235.21Z",
    transform: "translate(-78.649 -194.878)",
    fill: "#102633"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadows--inject-209",
    transform: "translate(34.798 152.922)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--Shadow--inject-209",
    d: "M135.531,306.883l-90.8-52.423c-1.676-.968-1.676-2.539,0-3.507l102.215-59a6.712,6.712,0,0,1,6.074,0L243.8,244.374c1.676.968,1.676,2.539,0,3.507l-102.194,59A6.713,6.713,0,0,1,135.531,306.883Z",
    transform: "translate(-43.478 -191.224)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67385",
    "data-name": "Path 67385",
    d: "M335.626,378.153l-39.65-22.74a.807.807,0,0,1,0-1.529l39.65-23.02a2.918,2.918,0,0,1,2.651,0l39.65,22.894a.807.807,0,0,1,0,1.529l-39.65,22.894a2.939,2.939,0,0,1-2.651-.028Z",
    transform: "translate(-118.709 -232.825)",
    opacity: 0.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Chip--inject-209",
    transform: "translate(184.575 235.067)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--chip--inject-209-2",
    "data-name": "freepik--chip--inject-209",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_67386",
    "data-name": "Path 67386",
    d: "M323.294,386.876l-65.371-37.469a1.332,1.332,0,0,1,0-2.525l65.385-38.016a4.8,4.8,0,0,1,4.37,0l65.4,37.735a1.333,1.333,0,0,1,0,2.525l-65.371,37.742A4.861,4.861,0,0,1,323.294,386.876Z",
    transform: "translate(-257.016 -308.34)",
    fill: "#102633",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67387",
    "data-name": "Path 67387",
    d: "M328.487,383.15l-54.471-31.226a1.108,1.108,0,0,1,0-2.1l54.471-31.654a4.033,4.033,0,0,1,3.64,0l54.478,31.458a1.112,1.112,0,0,1,0,2.1l-54.45,31.423a4.047,4.047,0,0,1-3.668,0Z",
    transform: "translate(-261.865 -311.144)",
    fill: "#102633",
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67388",
    "data-name": "Path 67388",
    d: "M332.867,380.094l-45.395-26.022a.926.926,0,0,1,0-1.753l45.4-26.394a3.339,3.339,0,0,1,3.037,0l45.395,26.211a.926.926,0,0,1,0,1.753l-45.395,26.2a3.374,3.374,0,0,1-3.044,0Z",
    transform: "translate(-265.923 -313.481)",
    fill: "#102633",
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67389",
    "data-name": "Path 67389",
    d: "M334.087,380.855a3.823,3.823,0,0,1-1.866-.449h0l-45.388-26.022a1.613,1.613,0,0,1,0-2.967l45.416-26.4a4.068,4.068,0,0,1,3.738,0l45.36,26.2a1.613,1.613,0,0,1,0,2.967L335.966,380.4A3.864,3.864,0,0,1,334.087,380.855Zm-1.136-1.662a2.714,2.714,0,0,0,2.343,0l45.353-26.218c.224-.133.281-.246.281-.267s-.056-.14-.281-.274l-45.381-26.2a2.651,2.651,0,0,0-2.336,0l-45.4,26.4c-.231.133-.281.245-.281.267s.049.14.281.274Z",
    transform: "translate(-265.627 -313.183)",
    fill: "#102633",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67390",
    "data-name": "Path 67390",
    d: "M334.232,380.658a3.507,3.507,0,0,1-1.69-.407h0l-45.395-26.022a1.271,1.271,0,0,1-.007-2.364l45.409-26.4a3.683,3.683,0,0,1,3.388,0l45.395,26.2a1.27,1.27,0,0,1,0,2.364l-45.395,26.211A3.507,3.507,0,0,1,334.232,380.658Zm-1.34-1.017a3.051,3.051,0,0,0,2.693,0l45.395-26.211c.288-.161.456-.372.456-.568s-.168-.407-.456-.575l-45.395-26.218a3.016,3.016,0,0,0-2.686,0L287.5,352.475a.751.751,0,0,0-.456.575c0,.2.168.4.456.568Z",
    transform: "translate(-265.772 -313.33)",
    fill: "#102633"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_63445",
    "data-name": "Group 63445",
    transform: "translate(20.921 12.078)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_67391",
    "data-name": "Path 67391",
    d: "M332.867,380.094l-45.395-26.022a.926.926,0,0,1,0-1.753l45.4-26.394a3.339,3.339,0,0,1,3.037,0l45.395,26.211a.926.926,0,0,1,0,1.753l-45.395,26.2a3.374,3.374,0,0,1-3.044,0Z",
    transform: "translate(-286.844 -325.559)",
    fill: "#102633",
    opacity: 0.5
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_67392",
    "data-name": "Path 67392",
    d: "M392.05,343.4l2.1,3.668,11.608-6.691h0a2.114,2.114,0,1,0-2.1-3.668h0Z",
    transform: "translate(-297.337 -316.727)",
    fill: "#102633"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67393",
    "data-name": "Path 67393",
    d: "M380.66,336.822l2.1,3.668,11.608-6.691h0a2.115,2.115,0,0,0-2.1-3.668h0Z",
    transform: "translate(-293.936 -314.762)",
    fill: "#102633"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67394",
    "data-name": "Path 67394",
    d: "M369.27,330.242l2.1,3.668,11.608-6.691h0a2.114,2.114,0,0,0-2.1-3.668h0Z",
    transform: "translate(-290.535 -312.798)",
    fill: "#102633"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67395",
    "data-name": "Path 67395",
    d: "M357.89,323.662l2.1,3.668,11.608-6.691h0a2.114,2.114,0,0,0-2.1-3.668h0Z",
    transform: "translate(-287.137 -310.833)",
    fill: "#102633"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_63446",
    "data-name": "Group 63446",
    transform: "translate(70.753 5.857)",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_67396",
    "data-name": "Path 67396",
    d: "M392.05,343.4l2.1,3.668,11.608-6.691h0a2.114,2.114,0,1,0-2.1-3.668h0Z",
    transform: "translate(-368.09 -322.584)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67397",
    "data-name": "Path 67397",
    d: "M380.66,336.822l2.1,3.668,11.608-6.691h0a2.115,2.115,0,0,0-2.1-3.668h0Z",
    transform: "translate(-364.689 -320.619)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67398",
    "data-name": "Path 67398",
    d: "M369.27,330.242l2.1,3.668,11.608-6.691h0a2.114,2.114,0,0,0-2.1-3.668h0Z",
    transform: "translate(-361.288 -318.655)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67399",
    "data-name": "Path 67399",
    d: "M357.89,323.662l2.1,3.668,11.608-6.691h0a2.114,2.114,0,0,0-2.1-3.668h0Z",
    transform: "translate(-357.89 -316.69)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_63447",
    "data-name": "Group 63447",
    transform: "translate(70.753 8.361)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_67400",
    "data-name": "Path 67400",
    d: "M392.05,344.468l2.118,3.668,9.862-5.7L399.793,340Z",
    transform: "translate(-368.09 -326.154)",
    fill: "#102633"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67401",
    "data-name": "Path 67401",
    d: "M369.856,322.708l-4.236-2.448-7.729,4.468,2.118,3.668Z",
    transform: "translate(-357.89 -320.26)",
    fill: "#102633"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67402",
    "data-name": "Path 67402",
    d: "M369.27,331.308l2.125,3.668,9.855-5.688-4.236-2.448Z",
    transform: "translate(-361.288 -322.225)",
    fill: "#102633"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67403",
    "data-name": "Path 67403",
    d: "M380.66,337.888l2.118,3.668,9.862-5.688L388.4,333.42Z",
    transform: "translate(-364.689 -324.19)",
    fill: "#102633"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_67404",
    "data-name": "Path 67404",
    d: "M310.92,343.4l-2.1,3.668-11.608-6.691h0a2.115,2.115,0,1,1,2.1-3.668h0Z",
    transform: "translate(-268.7 -316.727)",
    fill: "#102633"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67405",
    "data-name": "Path 67405",
    d: "M322.3,336.822l-2.1,3.668L308.548,333.8h0a2.114,2.114,0,1,1,2.1-3.668h0Z",
    transform: "translate(-272.086 -314.762)",
    fill: "#102633"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67406",
    "data-name": "Path 67406",
    d: "M333.71,330.242l-2.1,3.668L320,327.219h0a2.114,2.114,0,1,1,2.1-3.668h0Z",
    transform: "translate(-275.505 -312.798)",
    fill: "#102633"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67407",
    "data-name": "Path 67407",
    d: "M345.08,323.662l-2.1,3.668-11.608-6.691h0a2.114,2.114,0,0,1,2.1-3.668h0Z",
    transform: "translate(-278.9 -310.833)",
    fill: "#102633"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_63448",
    "data-name": "Group 63448",
    transform: "translate(27.445 5.857)",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_67408",
    "data-name": "Path 67408",
    d: "M310.92,343.4l-2.1,3.668-11.608-6.691h0a2.115,2.115,0,1,1,2.1-3.668h0Z",
    transform: "translate(-296.145 -322.584)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67409",
    "data-name": "Path 67409",
    d: "M322.3,336.822l-2.1,3.668L308.548,333.8h0a2.114,2.114,0,1,1,2.1-3.668h0Z",
    transform: "translate(-299.531 -320.619)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67410",
    "data-name": "Path 67410",
    d: "M333.71,330.242l-2.1,3.668L320,327.219h0a2.114,2.114,0,1,1,2.1-3.668h0Z",
    transform: "translate(-302.95 -318.655)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67411",
    "data-name": "Path 67411",
    d: "M345.08,323.662l-2.1,3.668-11.608-6.691h0a2.114,2.114,0,0,1,2.1-3.668h0Z",
    transform: "translate(-306.345 -316.69)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_63449",
    "data-name": "Group 63449",
    transform: "translate(30.24 8.361)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_67412",
    "data-name": "Path 67412",
    d: "M312.11,344.468l-2.118,3.668-9.862-5.7L304.366,340Z",
    transform: "translate(-300.13 -326.154)",
    fill: "#102633"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67413",
    "data-name": "Path 67413",
    d: "M334.31,322.708l4.237-2.448,7.729,4.468-2.118,3.668Z",
    transform: "translate(-310.336 -320.26)",
    fill: "#102633"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67414",
    "data-name": "Path 67414",
    d: "M334.89,331.308l-2.125,3.668-9.855-5.688,4.236-2.448Z",
    transform: "translate(-306.932 -322.225)",
    fill: "#102633"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67415",
    "data-name": "Path 67415",
    d: "M323.5,337.888l-2.118,3.668-9.862-5.688,4.236-2.448Z",
    transform: "translate(-303.531 -324.19)",
    fill: "#102633"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_67416",
    "data-name": "Path 67416",
    d: "M299.8,350.6a1.789,1.789,0,0,0,1.059,1.473l34.853,20.13a5.275,5.275,0,0,0,2.546.61v9.82a5.2,5.2,0,0,1-2.553-.61L302.353,362.8a5.653,5.653,0,0,1-2.553-4.426Z",
    transform: "translate(-269.791 -320.958)",
    fill: "#102633"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67417",
    "data-name": "Path 67417",
    d: "M299.8,350.6a1.789,1.789,0,0,0,1.059,1.473l34.853,20.13a5.275,5.275,0,0,0,2.546.61v9.82a5.2,5.2,0,0,1-2.553-.61L302.353,362.8a5.653,5.653,0,0,1-2.553-4.426Z",
    transform: "translate(-269.791 -320.958)",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67418",
    "data-name": "Path 67418",
    d: "M340.843,362.741l34.867-20.123c1.4-.814,1.4-2.1,0-2.953l-34.846-20.116a5.611,5.611,0,0,0-5.106,0l-34.846,20.116c-1.4.821-1.4,2.139,0,2.953l34.818,20.123A5.611,5.611,0,0,0,340.843,362.741Z",
    transform: "translate(-269.809 -311.503)",
    fill: "#102633"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67419",
    "data-name": "Path 67419",
    d: "M393.088,350.72v7.673a5.653,5.653,0,0,1-2.553,4.426l-33.352,19.254a5.2,5.2,0,0,1-2.553.61v-9.82a5.2,5.2,0,0,0,2.567-.617l34.867-20.137a1.866,1.866,0,0,0,1.024-1.389Z",
    transform: "translate(-286.163 -320.994)",
    fill: "#102633"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67420",
    "data-name": "Path 67420",
    d: "M393.088,350.66v7.715a5.653,5.653,0,0,1-2.553,4.426l-33.352,19.253a5.2,5.2,0,0,1-2.553.61v-9.82a5.225,5.225,0,0,0,2.567-.659l34.867-20.123A1.894,1.894,0,0,0,393.088,350.66Z",
    transform: "translate(-286.163 -320.976)",
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67421",
    "data-name": "Path 67421",
    d: "M341.973,360.557a3.619,3.619,0,0,1-1.8-.435L313.033,344.46a1.333,1.333,0,0,1,0-2.476l27.137-15.669a3.914,3.914,0,0,1,3.591,0l27.123,15.669a1.333,1.333,0,0,1,0,2.476l-27.123,15.662a3.577,3.577,0,0,1-1.789.435Zm0-33.976a3,3,0,0,0-1.445.344l-27.151,15.662a.835.835,0,0,0-.491.631c0,.217.182.449.5.631l27.144,15.669a3.255,3.255,0,0,0,2.883,0l27.116-15.669c.316-.182.491-.407.491-.631a.821.821,0,0,0-.491-.631L343.4,326.925a3,3,0,0,0-1.445-.344Z",
    transform: "translate(-273.492 -313.577)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67422",
    "data-name": "Path 67422",
    d: "M346.409,357.135a1.754,1.754,0,0,1-.856-.182l-17.977-10.29a.842.842,0,0,1-.456-.7.828.828,0,0,1,.456-.7l17.977-10.29a1.845,1.845,0,0,1,1.711,0l17.823,10.29a.758.758,0,0,1,0,1.4l-17.823,10.29a1.74,1.74,0,0,1-.856.182Zm-18.587-11.166a.462.462,0,0,0,.105.084l17.977,10.3a1.557,1.557,0,0,0,1.01,0l17.823-10.3a.351.351,0,0,0,.112-.091h0a.634.634,0,0,0-.112-.084l-17.823-10.29a1.157,1.157,0,0,0-1.01,0h0L327.927,345.87c-.077.049-.105.084-.105.1Zm17.907-10.682Z",
    transform: "translate(-277.949 -316.229)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67423",
    "data-name": "Path 67423",
    d: "M324.858,388.716a2.115,2.115,0,1,0,2.1,3.668l11.1-6.467a1.045,1.045,0,0,0,.442-.968,3.318,3.318,0,0,0-1.5-2.6,1.059,1.059,0,0,0-1.059-.105h0Z",
    transform: "translate(-276.956 -330.38)",
    fill: "#102633"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67424",
    "data-name": "Path 67424",
    d: "M313.468,382.136a2.114,2.114,0,1,0,2.1,3.668h0l11.1-6.467a1.045,1.045,0,0,0,.442-.968,3.318,3.318,0,0,0-1.5-2.6,1.059,1.059,0,0,0-1.059-.105h0l-11.1,6.467Z",
    transform: "translate(-273.555 -328.416)",
    fill: "#102633"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67425",
    "data-name": "Path 67425",
    d: "M302.076,375.554a2.118,2.118,0,1,0,2.1,3.675h0l11.1-6.467h0a1.052,1.052,0,0,0,.449-.954,3.3,3.3,0,0,0-1.494-2.6,1.045,1.045,0,0,0-1.059-.105h0l-11.11,6.46Z",
    transform: "translate(-270.153 -326.456)",
    fill: "#102633"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67426",
    "data-name": "Path 67426",
    d: "M289.88,371.864a2.1,2.1,0,0,0,2.9.779h0l11.131-6.467a1.038,1.038,0,0,0,.435-.968,3.3,3.3,0,0,0-1.494-2.6,1.024,1.024,0,0,0-1.059-.105h0l-11.1,6.46a2.1,2.1,0,0,0-.807,2.9Z",
    transform: "translate(-266.745 -324.484)",
    fill: "#102633"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67427",
    "data-name": "Path 67427",
    d: "M378.187,388.716a2.115,2.115,0,0,1-2.1,3.668l-11.1-6.467a1.045,1.045,0,0,1-.442-.968,3.318,3.318,0,0,1,1.5-2.6,1.059,1.059,0,0,1,1.059-.105h0Z",
    transform: "translate(-289.12 -330.38)",
    fill: "#102633"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67428",
    "data-name": "Path 67428",
    d: "M389.527,382.136a2.114,2.114,0,1,1-2.1,3.668h0l-11.1-6.467a1.045,1.045,0,0,1-.442-.968,3.318,3.318,0,0,1,1.5-2.6,1.059,1.059,0,0,1,1.059-.105h0l11.1,6.467Z",
    transform: "translate(-292.506 -328.416)",
    fill: "#102633"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67429",
    "data-name": "Path 67429",
    d: "M400.91,375.548a2.118,2.118,0,0,1-2.1,3.675h0l-11.1-6.467h0a1.052,1.052,0,0,1-.435-.968,3.3,3.3,0,0,1,1.494-2.6,1.045,1.045,0,0,1,1.059-.105h0l11.1,6.46Z",
    transform: "translate(-295.907 -326.45)",
    fill: "#102633"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67430",
    "data-name": "Path 67430",
    d: "M413.069,371.867a2.1,2.1,0,0,1-2.9.779h0l-11.1-6.46a1.045,1.045,0,0,1-.442-.968,3.3,3.3,0,0,1,1.5-2.6,1.024,1.024,0,0,1,1.059-.105h0l11.1,6.46a2.1,2.1,0,0,1,.779,2.89Z",
    transform: "translate(-299.299 -324.487)",
    fill: "#102633"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_63450",
    "data-name": "Group 63450",
    transform: "translate(22.852 37.923)",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_67431",
    "data-name": "Path 67431",
    d: "M324.858,388.716a2.115,2.115,0,1,0,2.1,3.668l11.1-6.467a1.045,1.045,0,0,0,.442-.968,3.318,3.318,0,0,0-1.5-2.6,1.059,1.059,0,0,0-1.059-.105h0Z",
    transform: "translate(-299.808 -368.303)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67432",
    "data-name": "Path 67432",
    d: "M313.468,382.136a2.114,2.114,0,1,0,2.1,3.668h0l11.1-6.467a1.045,1.045,0,0,0,.442-.968,3.318,3.318,0,0,0-1.5-2.6,1.059,1.059,0,0,0-1.059-.105h0l-11.1,6.467Z",
    transform: "translate(-296.407 -366.338)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67433",
    "data-name": "Path 67433",
    d: "M302.076,375.554a2.118,2.118,0,1,0,2.1,3.675h0l11.1-6.467h0a1.052,1.052,0,0,0,.449-.954,3.3,3.3,0,0,0-1.494-2.6,1.045,1.045,0,0,0-1.059-.105h0l-11.11,6.46Z",
    transform: "translate(-293.005 -364.378)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67434",
    "data-name": "Path 67434",
    d: "M289.88,371.864a2.1,2.1,0,0,0,2.9.779h0l11.131-6.467a1.038,1.038,0,0,0,.435-.968,3.3,3.3,0,0,0-1.494-2.6,1.024,1.024,0,0,0-1.059-.105h0l-11.1,6.46a2.1,2.1,0,0,0-.807,2.9Z",
    transform: "translate(-289.597 -362.406)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67435",
    "data-name": "Path 67435",
    d: "M378.187,388.716a2.115,2.115,0,0,1-2.1,3.668l-11.1-6.467a1.045,1.045,0,0,1-.442-.968,3.318,3.318,0,0,1,1.5-2.6,1.059,1.059,0,0,1,1.059-.105h0Z",
    transform: "translate(-311.972 -368.303)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67436",
    "data-name": "Path 67436",
    d: "M389.527,382.136a2.114,2.114,0,1,1-2.1,3.668h0l-11.1-6.467a1.045,1.045,0,0,1-.442-.968,3.318,3.318,0,0,1,1.5-2.6,1.059,1.059,0,0,1,1.059-.105h0l11.1,6.467Z",
    transform: "translate(-315.358 -366.338)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67437",
    "data-name": "Path 67437",
    d: "M400.91,375.548a2.118,2.118,0,0,1-2.1,3.675h0l-11.1-6.467h0a1.052,1.052,0,0,1-.435-.968,3.3,3.3,0,0,1,1.494-2.6,1.045,1.045,0,0,1,1.059-.105h0l11.1,6.46Z",
    transform: "translate(-318.759 -364.372)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67438",
    "data-name": "Path 67438",
    d: "M413.069,371.867a2.1,2.1,0,0,1-2.9.779h0l-11.1-6.46a1.045,1.045,0,0,1-.442-.968,3.3,3.3,0,0,1,1.5-2.6,1.024,1.024,0,0,1,1.059-.105h0l11.1,6.46a2.1,2.1,0,0,1,.779,2.89Z",
    transform: "translate(-322.151 -362.409)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-209",
    transform: "translate(48.66 62.949)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--device--inject-209-2",
    "data-name": "freepik--device--inject-209"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Laptop--inject-209"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_67439",
    "data-name": "Path 67439",
    d: "M70.05,261.024a5.478,5.478,0,0,0,2.546,4.208l71.354,41.193a5.611,5.611,0,0,0,5.092,0l97.635-56.365a4.784,4.784,0,0,0,0-8.459L175.324,200.43a5.611,5.611,0,0,0-5.092,0L72.6,256.795a5.478,5.478,0,0,0-2.546,4.229Z",
    transform: "translate(-65.273 -103.818)",
    fill: "#102633"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67440",
    "data-name": "Path 67440",
    d: "M146.5,325.871v5.513a5.156,5.156,0,0,1-2.546-.6L72.6,289.581a4.77,4.77,0,0,1-.26-8.291c-1.136.814-1.052,2.013.26,2.806l71.361,41.179a5.162,5.162,0,0,0,2.546.6Z",
    transform: "translate(-65.274 -128.145)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67441",
    "data-name": "Path 67441",
    d: "M65.632,216.02a5.436,5.436,0,0,1-2.392-4.335V124.444a5.611,5.611,0,0,1,2.546-4.412l97.635-56.344a4.784,4.784,0,0,1,7.323,4.208v87.255a5.646,5.646,0,0,1-2.546,4.412L70.563,215.928A5.436,5.436,0,0,1,65.632,216.02Z",
    transform: "translate(-63.24 -62.951)",
    fill: "#102633"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67442",
    "data-name": "Path 67442",
    d: "M70.261,241.192a4.767,4.767,0,0,1-7.021-4.4V149.554a5.071,5.071,0,0,1,.751-2.5l4.777,2.771h0a5.169,5.169,0,0,0-.75,2.5V239.6C68.017,241.073,69,241.753,70.261,241.192Z",
    transform: "translate(-63.24 -88.061)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67443",
    "data-name": "Path 67443",
    d: "M70.05,128.535v87.283c0,1.62,1.143,2.28,2.546,1.466l97.635-56.365a5.646,5.646,0,0,0,2.546-4.412V69.225c0-1.627-1.143-2.287-2.546-1.473L72.6,124.123a5.611,5.611,0,0,0-2.546,4.412Z",
    transform: "translate(-65.273 -64.279)",
    fill: "#fff",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67444",
    "data-name": "Path 67444",
    d: "M73.232,259.734l71.354,41.214a5.611,5.611,0,0,0,5.092,0l97.635-56.372c1.4-.807,1.4-2.1,0-2.939L175.96,200.43a5.611,5.611,0,0,0-5.092,0L73.232,256.795C71.829,257.608,71.829,258.927,73.232,259.734Z",
    transform: "translate(-65.909 -103.818)",
    fill: "#102633"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67445",
    "data-name": "Path 67445",
    d: "M73.232,259.734l71.354,41.214a5.611,5.611,0,0,0,5.092,0l97.635-56.372c1.4-.807,1.4-2.1,0-2.939L175.96,200.43a5.611,5.611,0,0,0-5.092,0L73.232,256.795C71.829,257.608,71.829,258.927,73.232,259.734Z",
    transform: "translate(-65.909 -103.818)",
    fill: "#fff",
    opacity: 0.85
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67446",
    "data-name": "Path 67446",
    d: "M74.989,131.783l94.128-54.331c.842-.484,1.529-.091,1.529.884V154.15a3.374,3.374,0,0,1-1.529,2.644L74.989,211.125c-.849.491-1.529.1-1.529-.877V134.434a3.381,3.381,0,0,1,1.529-2.651Z",
    transform: "translate(-66.292 -67.218)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67447",
    "data-name": "Path 67447",
    d: "M85.266,259.7l90.621-52.318a2.806,2.806,0,0,1,2.553,0l4.629,2.672a.779.779,0,0,1,0,1.473L92.434,263.835a2.805,2.805,0,0,1-2.546,0l-4.622-2.665a.779.779,0,0,1,0-1.473Z",
    transform: "translate(-69.66 -105.984)",
    fill: "#102633"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67448",
    "data-name": "Path 67448",
    d: "M85.266,259.7l90.621-52.318a2.806,2.806,0,0,1,2.553,0l4.629,2.672a.779.779,0,0,1,0,1.473L92.434,263.835a2.805,2.805,0,0,1-2.546,0l-4.622-2.665a.779.779,0,0,1,0-1.473Z",
    transform: "translate(-69.66 -105.984)",
    fill: "#fff",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67449",
    "data-name": "Path 67449",
    d: "M102.3,269.527l90.621-52.318a2.806,2.806,0,0,1,2.553,0l28.505,16.462a.774.774,0,0,1,0,1.466L133.5,287.385a2.805,2.805,0,0,1-2.553,0l-28.638-16.406a.772.772,0,0,1-.007-1.452Z",
    transform: "translate(-74.753 -108.919)",
    fill: "#102633"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67450",
    "data-name": "Path 67450",
    d: "M102.3,269.527l90.621-52.318a2.806,2.806,0,0,1,2.553,0l28.505,16.462a.774.774,0,0,1,0,1.466L133.5,287.385a2.805,2.805,0,0,1-2.553,0l-28.638-16.406a.772.772,0,0,1-.007-1.452Z",
    transform: "translate(-74.753 -108.919)",
    fill: "#fff",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67451",
    "data-name": "Path 67451",
    d: "M184.621,241.693l2.806-1.641c.119-.07.112-.182,0-.26l-3.283-1.894a.484.484,0,0,0-.449,0l-2.806,1.634a.14.14,0,0,0,0,.26l3.276,1.9a.519.519,0,0,0,.456,0Zm-5.611-6.509-2.827,1.669c-.119.07-.112.189,0,.267l3.29,1.838a.519.519,0,0,0,.456,0l2.806-1.641c.126-.063.112-.182,0-.26l-3.283-1.894a.484.484,0,0,0-.428.021Zm-9.167,5.289-4.8,2.806c-.119.07-.112.182,0,.26l3.283,1.894a.5.5,0,0,0,.456,0l4.8-2.771c.126-.07.119-.189,0-.26l-3.283-1.894a.484.484,0,0,0-.435-.035Zm5.015-2.9-2.806,1.641c-.119.07-.112.182,0,.26l3.283,1.894a.5.5,0,0,0,.456,0l2.806-1.634a.14.14,0,0,0,0-.26l-3.283-1.894a.5.5,0,0,0-.442-.028ZM163.727,244l-2.806,1.641a.14.14,0,0,0,0,.26l3.283,1.894a.5.5,0,0,0,.456,0l2.806-1.641a.14.14,0,0,0,0-.26L164.182,244a.519.519,0,0,0-.442,0Zm-4.145,2.4-2.806,1.634c-.126.07-.112.189,0,.267l3.283,1.894a.505.505,0,0,0,.449,0l2.806-1.641c.119-.07.112-.182,0-.26L160.03,246.4a.5.5,0,0,0-.435,0Zm12.906,7.715,2.841-1.641c.119-.063.112-.182,0-.26l-3.276-1.894a.5.5,0,0,0-.456,0l-2.806,1.634c-.126.07-.119.189,0,.267l3.283,1.894a.505.505,0,0,0,.428-.014Zm-4.131,2.378,2.806-1.634c.126-.07.119-.189,0-.26l-3.283-1.894a.484.484,0,0,0-.449,0l-2.806,1.641c-.119.07-.112.182,0,.26L167.9,256.5A.5.5,0,0,0,168.356,256.492Zm-4.145,2.4,2.806-1.641c.119-.07.112-.182,0-.259l-3.283-1.894a.484.484,0,0,0-.449,0l-2.841,1.634a.14.14,0,0,0,0,.26l3.283,1.894A.5.5,0,0,0,164.21,258.891Zm-4.152,2.392,2.841-1.634c.119-.07.112-.189,0-.267l-3.283-1.894a.519.519,0,0,0-.456,0l-2.806,1.634c-.119.07-.112.189,0,.267l3.283,1.894a.505.505,0,0,0,.421,0Zm20.418-17.2,2.806-1.634c.119-.07.112-.189,0-.267L180,240.29a.505.505,0,0,0-.449,0l-2.806,1.641c-.119.063-.112.182,0,.26l3.283,1.894a.5.5,0,0,0,.449,0Zm-3.809,7.624,6.313-3.654c.119-.07.112-.189,0-.267L175,243.166a.5.5,0,0,0-.456,0l-3.276,1.894c-.119.07-.112.182,0,.26l4.208,2.434c.126.077.133.2,0,.26l-2.616,1.515a.14.14,0,0,0,0,.26l3.283,1.894A.484.484,0,0,0,176.667,251.709Zm-21.217-2.932-2.841,1.641c-.119.07-.112.182,0,.26l3.276,1.894a.5.5,0,0,0,.456,0l2.806-1.634a.14.14,0,0,0,0-.26l-3.24-1.9A.519.519,0,0,0,155.45,248.777Zm-4.145,2.392-2.841,1.641a.14.14,0,0,0,0,.26l3.283,1.894a.5.5,0,0,0,.456,0l2.806-1.641c.126-.07.112-.182,0-.26l-3.283-1.894a.505.505,0,0,0-.421.014Zm-20.726,26.85a.519.519,0,0,0,.456,0l2.806-1.641a.14.14,0,0,0,0-.26l-3.283-1.894a.484.484,0,0,0-.449,0l-2.806,1.641a.14.14,0,0,0,0,.26Zm-12.45-7.715-2.841,1.641c-.119.07-.112.182,0,.26l3.276,1.894a.519.519,0,0,0,.456,0l2.806-1.641c.126-.07.119-.189,0-.26l-3.283-1.894a.484.484,0,0,0-.414.035Zm6.67,5.611a.5.5,0,0,0,.456,0l2.806-1.641c.126-.07.119-.189,0-.26l-3.283-1.894a.484.484,0,0,0-.449,0l-2.841,1.641a.14.14,0,0,0,0,.26Zm13.1,3.507,2.841-1.641c.119-.07.112-.182,0-.26l-3.276-1.894a.5.5,0,0,0-.456,0l-2.806,1.634c-.126.07-.119.189,0,.259l3.283,1.894a.484.484,0,0,0,.414.077Zm-4.6,2.385a.519.519,0,0,0,.456,0l2.806-1.641c.126-.063.119-.182,0-.26l-3.283-1.894a.505.505,0,0,0-.449,0l-2.841,1.634c-.119.07-.112.189,0,.267Zm-11.026-13.93-2.806,1.641c-.119.063-.112.182,0,.26l3.283,1.894a.484.484,0,0,0,.449,0l2.841-1.634c.119-.07.112-.189,0-.267l-3.276-1.894a.519.519,0,0,0-.491.07ZM143,255.973l-2.806,1.641c-.119.07-.112.182,0,.26l3.283,1.894a.484.484,0,0,0,.449,0l2.841-1.634a.14.14,0,0,0,0-.26l-3.283-1.894A.5.5,0,0,0,143,255.973Zm-16.588,9.581-2.806,1.634a.14.14,0,0,0,0,.26l3.283,1.894a.484.484,0,0,0,.449,0l2.841-1.641c.119-.07.112-.182,0-.259l-3.283-1.894a.5.5,0,0,0-.477.007Zm20.733-11.973-2.806,1.634c-.119.07-.112.189,0,.267l3.283,1.894a.519.519,0,0,0,.456,0l2.806-1.634c.119-.07.112-.189,0-.267l-3.283-1.894a.5.5,0,0,0-.449,0Zm-8.291,4.791-2.806,1.634a.14.14,0,0,0,0,.26l3.283,1.894a.484.484,0,0,0,.449,0l2.806-1.641c.119-.07.112-.182,0-.26l-3.283-1.894a.484.484,0,0,0-.442.007Zm-4.145,2.392-2.841,1.634c-.119.07-.112.189,0,.267l3.283,1.894a.519.519,0,0,0,.456,0l2.806-1.634c.126-.07.112-.189,0-.267l-3.283-1.894a.5.5,0,0,0-.414,0Zm-4.145,2.392-2.841,1.641c-.119.07-.112.182,0,.26l3.283,1.894a.5.5,0,0,0,.456,0l2.806-1.634a.14.14,0,0,0,0-.26l-3.283-1.894a.484.484,0,0,0-.414-.007Zm21.2,2.918,2.806-1.641c.126-.07.119-.182,0-.26l-3.283-1.894a.484.484,0,0,0-.449,0l-2.806,1.634a.14.14,0,0,0,0,.26l3.276,1.894a.5.5,0,0,0,.463.007Zm36.424-36.185-2.841,1.641c-.119.07-.112.182,0,.26l3.283,1.894a.5.5,0,0,0,.456,0l2.806-1.634a.14.14,0,0,0,0-.26l-3.283-1.894a.484.484,0,0,0-.414-.007Zm-5.022,2.9-2.841,1.641a.14.14,0,0,0,0,.26l3.276,1.894a.5.5,0,0,0,.456,0l2.841-1.641a.14.14,0,0,0,0-.26l-3.283-1.894a.505.505,0,0,0-.442,0Zm9.167-5.289-2.834,1.641c-.119.07-.112.189,0,.267l3.276,1.894a.519.519,0,0,0,.456,0l2.841-1.634c.119-.07.112-.189,0-.267l-3.283-1.894a.5.5,0,0,0-.449-.007Zm-21.463,22.136,2.806-1.641c.119-.07.112-.182,0-.26l-3.283-1.894a.505.505,0,0,0-.449,0l-2.841,1.641a.14.14,0,0,0,0,.26l3.283,1.894a.5.5,0,0,0,.491,0Zm26.064-24.549a.5.5,0,0,0-.456,0l-2.806,1.634c-.126.07-.119.189,0,.26l3.283,1.894a.484.484,0,0,0,.449,0l2.806-1.641c.119-.07.112-.182,0-.26Zm-41.025,38.577,2.841-1.634a.14.14,0,0,0,0-.26l-3.276-1.894a.5.5,0,0,0-.456,0l-2.806,1.641c-.126.07-.119.182,0,.26l3.283,1.894a.484.484,0,0,0,.421.007ZM206.765,234.3l2.806-1.634a.14.14,0,0,0,0-.26l-3.262-1.866a.5.5,0,0,0-.449,0l-2.841,1.641c-.119.07-.112.182,0,.26l3.283,1.894a.5.5,0,0,0,.47-.021Zm-8.838-.309,2.841-1.641c.119-.07.112-.182,0-.26l-3.276-1.894a.5.5,0,0,0-.456,0l-2.806,1.634c-.126.07-.119.189,0,.267l3.283,1.894a.505.505,0,0,0,.421.014Zm3.689-6.186a.5.5,0,0,0-.456,0l-2.806,1.641a.14.14,0,0,0,0,.26l3.283,1.894a.5.5,0,0,0,.449,0l2.841-1.641a.14.14,0,0,0,0-.26Zm.87-.505,7.975,4.643a.519.519,0,0,0,.456,0l2.806-1.641c.126-.063.119-.182,0-.26l-7.968-4.6a.5.5,0,0,0-.449,0l-2.806,1.641c-.14.035-.133.154-.007.231Zm-9.616,5.282-2.841,1.641c-.119.063-.112.182,0,.26l3.276,1.894a.5.5,0,0,0,.456,0l2.841-1.634c.119-.07.112-.189,0-.267l-3.283-1.894a.505.505,0,0,0-.442.014ZM161.657,250.6l-2.806,1.641c-.126.07-.119.182,0,.26l3.283,1.894a.484.484,0,0,0,.449,0l2.841-1.634a.14.14,0,0,0,0-.26l-3.276-1.894a.5.5,0,0,0-.484.007Zm40.506-13.916a.5.5,0,0,0,.456,0l2.806-1.641c.119-.07.112-.182,0-.26l-3.283-1.894a.519.519,0,0,0-.456,0l-2.806,1.641a.14.14,0,0,0,0,.26ZM165.8,248.209,163,249.843c-.119.07-.112.189,0,.267L166.28,252a.5.5,0,0,0,.449,0l2.841-1.641c.119-.063.112-.182,0-.26l-3.283-1.894a.5.5,0,0,0-.477.014Zm-31.079,27.432a.5.5,0,0,0,.456,0l2.841-1.613c.119-.07.112-.189,0-.267l-3.283-1.894a.505.505,0,0,0-.449,0l-2.841,1.641c-.119.063-.112.182,0,.26Zm-6.235-5.871-2.806,1.641c-.126.063-.119.182,0,.26l3.283,1.894a.484.484,0,0,0,.449,0l2.806-1.634c.119-.07.112-.189,0-.267l-3.276-1.894A.519.519,0,0,0,128.488,269.77Zm10.837,3.507,2.841-1.641c.119-.07.112-.182,0-.26l-3.276-1.894a.5.5,0,0,0-.456,0l-2.806,1.634c-.126.07-.119.189,0,.26l3.283,1.9a.5.5,0,0,0,.414-.021Zm4.145-2.392,2.841-1.641a.14.14,0,0,0,0-.26l-3.283-1.894a.5.5,0,0,0-.456,0l-2.806,1.641c-.119.07-.112.182,0,.26l3.283,1.894a.505.505,0,0,0,.421-.021Zm4.152-2.4,2.806-1.634c.119-.07.112-.189,0-.267l-3.283-1.894a.505.505,0,0,0-.449,0l-2.806,1.634c-.119.07-.112.189,0,.267l3.283,1.894a.519.519,0,0,0,.449-.021ZM132.633,267.4l-2.806,1.634c-.119.07-.112.189,0,.267l3.283,1.894a.5.5,0,0,0,.449,0l2.806-1.641c.119-.07.112-.182,0-.259l-3.283-1.894a.5.5,0,0,0-.449-.021Zm4.152-2.4-2.806,1.641c-.119.07-.112.182,0,.26l3.283,1.894a.519.519,0,0,0,.456,0l2.806-1.641a.14.14,0,0,0,0-.26L137.242,265a.484.484,0,0,0-.456-.021Zm16.588-9.574-2.806,1.634c-.119.07-.112.189,0,.267l3.283,1.894a.519.519,0,0,0,.456,0l2.806-1.634c.119-.07.112-.189,0-.267l-3.283-1.894a.505.505,0,0,0-.456-.021Zm-4.152,2.392-2.806,1.641c-.119.07-.112.182,0,.26l3.283,1.894a.484.484,0,0,0,.449,0l2.841-1.634a.14.14,0,0,0,0-.259l-3.283-1.894a.5.5,0,0,0-.484-.028Zm8.3-4.833-2.806,1.634a.14.14,0,0,0,0,.26l3.276,1.894a.5.5,0,0,0,.456,0l2.806-1.641c.126-.07.119-.182,0-.26l-3.283-1.894a.484.484,0,0,0-.449.007Zm-16.588,9.574-2.841,1.648c-.119.063-.112.182,0,.26l3.276,1.894a.519.519,0,0,0,.456,0l2.806-1.634c.126-.07.119-.189,0-.267l-3.283-1.894a.5.5,0,0,0-.414.021Zm4.145-2.392-2.841,1.634a.14.14,0,0,0,0,.26l3.283,1.9a.5.5,0,0,0,.449,0l2.841-1.641c.119-.07.112-.182,0-.26l-3.276-1.894a.5.5,0,0,0-.428.028Zm-3.03,16.9,2.841-1.634a.14.14,0,0,0,0-.26l-3.29-1.845a.519.519,0,0,0-.456,0l-2.806,1.641c-.119.07-.112.182,0,.26l3.283,1.894a.484.484,0,0,0,.428-.028Zm-24.3-2.427-3.283-1.894a.484.484,0,0,0-.449,0l-2.806,1.634a.14.14,0,0,0,0,.26l3.283,1.9a.519.519,0,0,0,.456,0l2.806-1.641C117.848,274.827,117.841,274.729,117.75,274.638Zm6.214,1.824-3.283-1.894a.484.484,0,0,0-.449,0l-4.37,2.518a.14.14,0,0,0,0,.26l3.276,1.894a.5.5,0,0,0,.456,0l4.363-2.525c.105-.063.105-.175-.028-.253Zm-11.222-5.485-3.283-1.894a.484.484,0,0,0-.449,0L105.5,271.1a.14.14,0,0,0,0,.259l3.283,1.894a.5.5,0,0,0,.456,0l3.507-2.02c.091-.063.091-.175-.07-.253Zm2.679-1.543a.505.505,0,0,0,.449,0l2.806-1.641c.119-.07.112-.182,0-.26l-3.283-1.894a.5.5,0,0,0-.456,0l-2.806,1.634a.14.14,0,0,0,0,.26Zm14.351,9.118-3.283-1.894a.5.5,0,0,0-.456,0l-5.457,3.149c-.119.07-.112.182,0,.26l3.283,1.894a.505.505,0,0,0,.449,0l5.457-3.156c.077-.077.07-.189-.056-.267Zm2.721,3.844L129.21,280.5a.484.484,0,0,0-.449,0l-3.507,2.02c-.119.07-.112.182,0,.259l3.283,1.894a.484.484,0,0,0,.449,0l3.507-2.013a.176.176,0,0,0-.063-.281Zm13.762-30.75a.505.505,0,0,0,.449,0L149.544,250c.119-.07.112-.182,0-.26l-3.283-1.894a.5.5,0,0,0-.456,0L143,249.485a.14.14,0,0,0,0,.26Zm-8.3,4.784a.5.5,0,0,0,.456,0l2.806-1.641c.126-.07.119-.189,0-.26l-3.283-1.894a.484.484,0,0,0-.449,0l-2.806,1.641a.14.14,0,0,0,0,.26ZM119.5,267.013a.519.519,0,0,0,.456,0l2.806-1.641a.14.14,0,0,0,0-.26l-3.283-1.894a.484.484,0,0,0-.449,0l-2.806,1.641c-.119.07-.112.182,0,.26ZM142.046,254a.484.484,0,0,0,.449,0l2.841-1.634c.119-.07.112-.189,0-.267l-3.276-1.894a.519.519,0,0,0-.456,0l-2.806,1.641c-.126.063-.119.182,0,.26Zm-8.3,4.791a.519.519,0,0,0,.456,0l2.806-1.641c.119-.07.112-.182,0-.26L133.728,255a.484.484,0,0,0-.449,0l-2.806,1.634c-.119.07-.112.189,0,.267Zm.961,23.848a.5.5,0,0,0-.456,0l-4.363,2.518c-.119.07-.112.189,0,.267l3.29,1.929a.519.519,0,0,0,.456,0L138,284.836a.14.14,0,0,0,0-.26ZM127.8,262.195a.484.484,0,0,0,.449,0l2.841-1.641c.119-.07.112-.182,0-.26l-3.276-1.894a.5.5,0,0,0-.456,0l-2.806,1.634c-.126.07-.119.189,0,.26Zm-4.152,2.4a.5.5,0,0,0,.456,0l2.806-1.634c.126-.07.119-.189,0-.267l-3.283-1.894a.505.505,0,0,0-.449,0l-2.806,1.641c-.119.063-.112.182,0,.26Zm87.886-26.317a.5.5,0,0,0-.449,0l-7.014,4.033a.14.14,0,0,0,0,.26l3.283,1.894a.5.5,0,0,0,.456,0l7.014-4.033a.14.14,0,0,0,0-.26Zm-9.167,5.3a.484.484,0,0,0-.449,0l-2.806,1.7c-.119.07-.112.189,0,.267l3.276,1.894a.519.519,0,0,0,.456,0l2.806-1.641c.119-.07.112-.182,0-.26ZM146.2,274.729,149,273.088c.119-.063.112-.182,0-.26l-3.283-1.894a.484.484,0,0,0-.449,0l-2.806,1.634c-.119.07-.112.189,0,.267l3.283,1.894A.519.519,0,0,0,146.2,274.729Zm47.878-26.289a.5.5,0,0,0-.456,0l-2.806,1.641a.14.14,0,0,0,0,.26l3.283,1.894a.5.5,0,0,0,.456,0l2.806-1.641a.14.14,0,0,0,0-.26Zm21.61-12.478a.5.5,0,0,0-.456,0l-2.806,1.634c-.126.07-.119.189,0,.267l3.283,1.894a.505.505,0,0,0,.449,0L219,238.116c.119-.07.112-.182,0-.26Zm7.428-.5-7.968-4.6a.5.5,0,0,0-.456,0l-2.806,1.634c-.126.07-.119.189,0,.26l7.968,4.6a.484.484,0,0,0,.449,0l2.841-1.641c.105-.091.1-.21-.028-.267Zm-44.532,21.919a.519.519,0,0,0-.456,0l-3.507,2.013c-.119.07-.112.189,0,.267l3.283,1.894a.519.519,0,0,0,.456,0l3.507-2.013c.119-.07.112-.189,0-.267Zm10.472-6.046a.484.484,0,0,0-.449,0l-4.37,2.518a.14.14,0,0,0,0,.26l3.276,1.894a.5.5,0,0,0,.456,0l4.363-2.525c.126-.07.112-.182,0-.26Zm-20.1,11.566a.505.505,0,0,0-.449,0l-23.357,13.488c-.119.07-.112.182,0,.26l3.276,1.894a.519.519,0,0,0,.456,0l23.35-13.488c.126-.07.119-.182,0-.26Zm-24.661,14.238a.484.484,0,0,0-.449,0l-3.507,2.013c-.126.07-.119.189,0,.259l3.283,1.894a.484.484,0,0,0,.449,0l3.507-2.02c.119-.07.112-.182,0-.26Zm29.459-17.009a.5.5,0,0,0-.456,0l-3.507,2.02c-.126.07-.119.182,0,.26l3.283,1.894a.484.484,0,0,0,.449,0l3.507-2.013a.14.14,0,0,0,0-.259Zm-34.257,19.78a.5.5,0,0,0-.449,0l-3.507,2.013c-.119.07-.112.189,0,.267l3.283,1.894a.519.519,0,0,0,.456,0l3.507-2.013c.119-.07.112-.189,0-.267Zm43.873-25.328a.484.484,0,0,0-.449,0L179.41,256.6a.14.14,0,0,0,0,.259l3.283,1.9a.505.505,0,0,0,.449,0l3.507-2.02c.119-.07.112-.182,0-.26Zm14.842-8.571a.505.505,0,0,0-.449,0l-2.855,1.634c-.119.07-.112.182,0,.26l3.283,1.894a.5.5,0,0,0,.456,0l2.806-1.634c.119-.07.112-.189,0-.267Zm9.118-6.6,2.806-1.634a.14.14,0,0,0,0-.26l-3.283-1.894a.484.484,0,0,0-.449,0l-2.806,1.641c-.119.07-.112.182,0,.26l3.283,1.894a.5.5,0,0,0,.435-.007Zm-18.545-.119,2.841-1.634a.14.14,0,0,0,0-.26l-3.283-1.894a.5.5,0,0,0-.456,0l-2.806,1.641c-.126.07-.112.182,0,.26l3.283,1.894a.484.484,0,0,0,.407-.007Zm-9.392,16.252,8.291-4.791c.119-.063.112-.182,0-.26L184.4,248.6a.505.505,0,0,0-.449,0l-8.3,4.791c-.119.063-.112.182,0,.26l3.283,1.894a.519.519,0,0,0,.442,0ZM202.725,241.8a.505.505,0,0,0,.449,0l2.806-1.641c.119-.07.112-.182,0-.26L202.7,238.01a.5.5,0,0,0-.456,0l-2.806,1.634a.14.14,0,0,0,0,.26Zm-4.208-2.7,2.806-1.641c.119-.063.112-.182,0-.26l-3.276-1.894a.519.519,0,0,0-.456,0l-2.806,1.634c-.126.07-.119.189,0,.267l3.283,1.894a.505.505,0,0,0,.407,0Zm-23.252,18.84,2.841-1.641a.14.14,0,0,0,0-.259l-3.283-1.894a.5.5,0,0,0-.456,0l-2.806,1.641c-.119.07-.112.182,0,.26l3.283,1.894a.505.505,0,0,0,.379,0Zm18.321-10.851a.5.5,0,0,0,.456,0l2.806-1.634a.14.14,0,0,0,0-.26l-3.283-1.894a.5.5,0,0,0-.456,0l-2.806,1.641c-.119.07-.112.182,0,.26ZM154.531,269.91l2.841-1.634a.14.14,0,0,0,0-.26l-3.276-1.9a.519.519,0,0,0-.456,0l-2.806,1.641c-.126.07-.119.182,0,.26l3.283,1.894a.484.484,0,0,0,.372,0Zm4.145-2.392,2.841-1.641c.119-.07.112-.182,0-.259l-3.283-1.894a.5.5,0,0,0-.456,0l-2.806,1.634c-.119.07-.112.189,0,.267l3.283,1.894a.505.505,0,0,0,.379,0Zm-8.291,4.791,2.806-1.641c.126-.07.119-.189,0-.259l-3.283-1.894a.505.505,0,0,0-.449,0l-2.806,1.641a.14.14,0,0,0,0,.259l3.276,1.894a.5.5,0,0,0,.414,0Zm16.588-9.581,2.806-1.634c.126-.07.119-.189,0-.267l-3.283-1.894a.505.505,0,0,0-.449,0l-2.806,1.641c-.119.063-.112.182,0,.259l3.276,1.894a.5.5,0,0,0,.414,0Zm-4.145,2.4,2.806-1.641a.14.14,0,0,0,0-.26l-3.283-1.894a.484.484,0,0,0-.449,0l-2.806,1.641a.14.14,0,0,0,0,.259l3.283,1.894a.5.5,0,0,0,.407,0Zm8.227-4.791,2.841-1.641c.119-.07.112-.182,0-.26l-3.276-1.894a.5.5,0,0,0-.456,0l-2.806,1.634c-.119.07-.112.189,0,.267l3.283,1.894a.505.505,0,0,0,.414,0Zm18.994-35.407a.5.5,0,0,0,.456,0l2.806-1.634a.14.14,0,0,0,0-.26l-.877-.505a.484.484,0,0,0-.449,0l-2.841,1.641a.14.14,0,0,0,0,.26Zm-20.4,13.158a.519.519,0,0,0,.456,0l2.806-1.634c.119-.07.112-.189,0-.267l-3.283-1.894a.519.519,0,0,0-.456,0l-2.806,1.634c-.119.07-.112.189,0,.267Zm8.291-4.791a.5.5,0,0,0,.456,0l2.806-1.634a.14.14,0,0,0,0-.26l-3.283-1.9a.5.5,0,0,0-.449,0l-2.806,1.641c-.119.07-.112.182,0,.26Zm-13.327,7.715a.519.519,0,0,0,.456,0l2.806-1.641c.119-.07.112-.182,0-.26l-3.283-1.894a.484.484,0,0,0-.449,0l-2.841,1.634c-.119.07-.112.189,0,.267Zm9.209-5.324a.5.5,0,0,0,.456,0l2.806-1.641c.119-.07.112-.182,0-.26l-3.283-1.894a.484.484,0,0,0-.449,0l-2.841,1.634a.14.14,0,0,0,0,.26ZM156.292,245.8a.484.484,0,0,0,.449,0l2.806-1.641a.14.14,0,0,0,0-.26L156.271,242a.519.519,0,0,0-.456,0l-2.806,1.641a.14.14,0,0,0,0,.26Zm4.145-2.392a.484.484,0,0,0,.449,0l2.841-1.634c.119-.07.112-.189,0-.267l-3.283-1.894a.519.519,0,0,0-.456,0l-2.806,1.641c-.119.07-.112.182,0,.26Zm21.323-13.7a.505.505,0,0,0,.449,0l2.806-1.634c.119-.07.112-.189,0-.267l-.87-.505a.519.519,0,0,0-.456,0l-2.806,1.641c-.119.07-.112.182,0,.26Zm12.443-7.182a.519.519,0,0,0,.456,0l2.806-1.641c.126-.063.119-.182,0-.26l-.87-.505a.519.519,0,0,0-.456,0l-2.841,1.641c-.119.063-.112.182,0,.26ZM201.1,226.5a.484.484,0,0,0,.449,0l2.806-1.634a.14.14,0,0,0,0-.26l-3.283-1.9a.519.519,0,0,0-.456,0l-2.806,1.641c-.119.07-.112.182,0,.26Zm10.367,10.521,2.806-1.634c.126-.07.119-.189,0-.267l-3.283-1.894a.505.505,0,0,0-.449,0l-2.841,1.634c-.119.07-.112.189,0,.267l3.276,1.894a.5.5,0,0,0,.484,0Zm-25.552-9.714a.484.484,0,0,0,.449,0l2.841-1.641c.119-.07.112-.182,0-.26l-.877-.505a.484.484,0,0,0-.449,0l-2.806,1.634c-.119.07-.112.189,0,.267Zm-33.794,20.888a.519.519,0,0,0,.456,0l2.806-1.641c.126-.063.119-.182,0-.26L152.1,244.4a.484.484,0,0,0-.449,0l-2.806,1.634c-.119.07-.112.189,0,.267Z",
    transform: "translate(-75.834 -109.863)",
    fill: "#102633"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67452",
    "data-name": "Path 67452",
    d: "M184.621,241.693l2.806-1.641c.119-.07.112-.182,0-.26l-3.283-1.894a.484.484,0,0,0-.449,0l-2.806,1.634a.14.14,0,0,0,0,.26l3.276,1.9a.519.519,0,0,0,.456,0Zm-5.611-6.509-2.827,1.669c-.119.07-.112.189,0,.267l3.29,1.838a.519.519,0,0,0,.456,0l2.806-1.641c.126-.063.112-.182,0-.26l-3.283-1.894a.484.484,0,0,0-.428.021Zm-9.167,5.289-4.8,2.806c-.119.07-.112.182,0,.26l3.283,1.894a.5.5,0,0,0,.456,0l4.8-2.771c.126-.07.119-.189,0-.26l-3.283-1.894a.484.484,0,0,0-.435-.035Zm5.015-2.9-2.806,1.641c-.119.07-.112.182,0,.26l3.283,1.894a.5.5,0,0,0,.456,0l2.806-1.634a.14.14,0,0,0,0-.26l-3.283-1.894a.5.5,0,0,0-.442-.028ZM163.727,244l-2.806,1.641a.14.14,0,0,0,0,.26l3.283,1.894a.5.5,0,0,0,.456,0l2.806-1.641a.14.14,0,0,0,0-.26L164.182,244a.519.519,0,0,0-.442,0Zm-4.145,2.4-2.806,1.634c-.126.07-.112.189,0,.267l3.283,1.894a.505.505,0,0,0,.449,0l2.806-1.641c.119-.07.112-.182,0-.26L160.03,246.4a.5.5,0,0,0-.435,0Zm12.906,7.715,2.841-1.641c.119-.063.112-.182,0-.26l-3.276-1.894a.5.5,0,0,0-.456,0l-2.806,1.634c-.126.07-.119.189,0,.267l3.283,1.894a.505.505,0,0,0,.428-.014Zm-4.131,2.378,2.806-1.634c.126-.07.119-.189,0-.26l-3.283-1.894a.484.484,0,0,0-.449,0l-2.806,1.641c-.119.07-.112.182,0,.26L167.9,256.5A.5.5,0,0,0,168.356,256.492Zm-4.145,2.4,2.806-1.641c.119-.07.112-.182,0-.259l-3.283-1.894a.484.484,0,0,0-.449,0l-2.841,1.634a.14.14,0,0,0,0,.26l3.283,1.894A.5.5,0,0,0,164.21,258.891Zm-4.152,2.392,2.841-1.634c.119-.07.112-.189,0-.267l-3.283-1.894a.519.519,0,0,0-.456,0l-2.806,1.634c-.119.07-.112.189,0,.267l3.283,1.894a.505.505,0,0,0,.421,0Zm20.418-17.2,2.806-1.634c.119-.07.112-.189,0-.267L180,240.29a.505.505,0,0,0-.449,0l-2.806,1.641c-.119.063-.112.182,0,.26l3.283,1.894a.5.5,0,0,0,.449,0Zm-3.809,7.624,6.313-3.654c.119-.07.112-.189,0-.267L175,243.166a.5.5,0,0,0-.456,0l-3.276,1.894c-.119.07-.112.182,0,.26l4.208,2.434c.126.077.133.2,0,.26l-2.616,1.515a.14.14,0,0,0,0,.26l3.283,1.894A.484.484,0,0,0,176.667,251.709Zm-21.217-2.932-2.841,1.641c-.119.07-.112.182,0,.26l3.276,1.894a.5.5,0,0,0,.456,0l2.806-1.634a.14.14,0,0,0,0-.26l-3.24-1.9A.519.519,0,0,0,155.45,248.777Zm-4.145,2.392-2.841,1.641a.14.14,0,0,0,0,.26l3.283,1.894a.5.5,0,0,0,.456,0l2.806-1.641c.126-.07.112-.182,0-.26l-3.283-1.894a.505.505,0,0,0-.421.014Zm-20.726,26.85a.519.519,0,0,0,.456,0l2.806-1.641a.14.14,0,0,0,0-.26l-3.283-1.894a.484.484,0,0,0-.449,0l-2.806,1.641a.14.14,0,0,0,0,.26Zm-12.45-7.715-2.841,1.641c-.119.07-.112.182,0,.26l3.276,1.894a.519.519,0,0,0,.456,0l2.806-1.641c.126-.07.119-.189,0-.26l-3.283-1.894a.484.484,0,0,0-.414.035Zm6.67,5.611a.5.5,0,0,0,.456,0l2.806-1.641c.126-.07.119-.189,0-.26l-3.283-1.894a.484.484,0,0,0-.449,0l-2.841,1.641a.14.14,0,0,0,0,.26Zm13.1,3.507,2.841-1.641c.119-.07.112-.182,0-.26l-3.276-1.894a.5.5,0,0,0-.456,0l-2.806,1.634c-.126.07-.119.189,0,.259l3.283,1.894a.484.484,0,0,0,.414.077Zm-4.6,2.385a.519.519,0,0,0,.456,0l2.806-1.641c.126-.063.119-.182,0-.26l-3.283-1.894a.505.505,0,0,0-.449,0l-2.841,1.634c-.119.07-.112.189,0,.267Zm-11.026-13.93-2.806,1.641c-.119.063-.112.182,0,.26l3.283,1.894a.484.484,0,0,0,.449,0l2.841-1.634c.119-.07.112-.189,0-.267l-3.276-1.894a.519.519,0,0,0-.491.07ZM143,255.973l-2.806,1.641c-.119.07-.112.182,0,.26l3.283,1.894a.484.484,0,0,0,.449,0l2.841-1.634a.14.14,0,0,0,0-.26l-3.283-1.894A.5.5,0,0,0,143,255.973Zm-16.588,9.581-2.806,1.634a.14.14,0,0,0,0,.26l3.283,1.894a.484.484,0,0,0,.449,0l2.841-1.641c.119-.07.112-.182,0-.259l-3.283-1.894a.5.5,0,0,0-.477.007Zm20.733-11.973-2.806,1.634c-.119.07-.112.189,0,.267l3.283,1.894a.519.519,0,0,0,.456,0l2.806-1.634c.119-.07.112-.189,0-.267l-3.283-1.894a.5.5,0,0,0-.449,0Zm-8.291,4.791-2.806,1.634a.14.14,0,0,0,0,.26l3.283,1.894a.484.484,0,0,0,.449,0l2.806-1.641c.119-.07.112-.182,0-.26l-3.283-1.894a.484.484,0,0,0-.442.007Zm-4.145,2.392-2.841,1.634c-.119.07-.112.189,0,.267l3.283,1.894a.519.519,0,0,0,.456,0l2.806-1.634c.126-.07.112-.189,0-.267l-3.283-1.894a.5.5,0,0,0-.414,0Zm-4.145,2.392-2.841,1.641c-.119.07-.112.182,0,.26l3.283,1.894a.5.5,0,0,0,.456,0l2.806-1.634a.14.14,0,0,0,0-.26l-3.283-1.894a.484.484,0,0,0-.414-.007Zm21.2,2.918,2.806-1.641c.126-.07.119-.182,0-.26l-3.283-1.894a.484.484,0,0,0-.449,0l-2.806,1.634a.14.14,0,0,0,0,.26l3.276,1.894a.5.5,0,0,0,.463.007Zm36.424-36.185-2.841,1.641c-.119.07-.112.182,0,.26l3.283,1.894a.5.5,0,0,0,.456,0l2.806-1.634a.14.14,0,0,0,0-.26l-3.283-1.894a.484.484,0,0,0-.414-.007Zm-5.022,2.9-2.841,1.641a.14.14,0,0,0,0,.26l3.276,1.894a.5.5,0,0,0,.456,0l2.841-1.641a.14.14,0,0,0,0-.26l-3.283-1.894a.505.505,0,0,0-.442,0Zm9.167-5.289-2.834,1.641c-.119.07-.112.189,0,.267l3.276,1.894a.519.519,0,0,0,.456,0l2.841-1.634c.119-.07.112-.189,0-.267l-3.283-1.894a.5.5,0,0,0-.449-.007Zm-21.463,22.136,2.806-1.641c.119-.07.112-.182,0-.26l-3.283-1.894a.505.505,0,0,0-.449,0l-2.841,1.641a.14.14,0,0,0,0,.26l3.283,1.894a.5.5,0,0,0,.491,0Zm26.064-24.549a.5.5,0,0,0-.456,0l-2.806,1.634c-.126.07-.119.189,0,.26l3.283,1.894a.484.484,0,0,0,.449,0l2.806-1.641c.119-.07.112-.182,0-.26Zm-41.025,38.577,2.841-1.634a.14.14,0,0,0,0-.26l-3.276-1.894a.5.5,0,0,0-.456,0l-2.806,1.641c-.126.07-.119.182,0,.26l3.283,1.894a.484.484,0,0,0,.421.007ZM206.765,234.3l2.806-1.634a.14.14,0,0,0,0-.26l-3.262-1.866a.5.5,0,0,0-.449,0l-2.841,1.641c-.119.07-.112.182,0,.26l3.283,1.894a.5.5,0,0,0,.47-.021Zm-8.838-.309,2.841-1.641c.119-.07.112-.182,0-.26l-3.276-1.894a.5.5,0,0,0-.456,0l-2.806,1.634c-.126.07-.119.189,0,.267l3.283,1.894a.505.505,0,0,0,.421.014Zm3.689-6.186a.5.5,0,0,0-.456,0l-2.806,1.641a.14.14,0,0,0,0,.26l3.283,1.894a.5.5,0,0,0,.449,0l2.841-1.641a.14.14,0,0,0,0-.26Zm.87-.505,7.975,4.643a.519.519,0,0,0,.456,0l2.806-1.641c.126-.063.119-.182,0-.26l-7.968-4.6a.5.5,0,0,0-.449,0l-2.806,1.641c-.14.035-.133.154-.007.231Zm-9.616,5.282-2.841,1.641c-.119.063-.112.182,0,.26l3.276,1.894a.5.5,0,0,0,.456,0l2.841-1.634c.119-.07.112-.189,0-.267l-3.283-1.894a.505.505,0,0,0-.442.014ZM161.657,250.6l-2.806,1.641c-.126.07-.119.182,0,.26l3.283,1.894a.484.484,0,0,0,.449,0l2.841-1.634a.14.14,0,0,0,0-.26l-3.276-1.894a.5.5,0,0,0-.484.007Zm40.506-13.916a.5.5,0,0,0,.456,0l2.806-1.641c.119-.07.112-.182,0-.26l-3.283-1.894a.519.519,0,0,0-.456,0l-2.806,1.641a.14.14,0,0,0,0,.26ZM165.8,248.209,163,249.843c-.119.07-.112.189,0,.267L166.28,252a.5.5,0,0,0,.449,0l2.841-1.641c.119-.063.112-.182,0-.26l-3.283-1.894a.5.5,0,0,0-.477.014Zm-31.079,27.432a.5.5,0,0,0,.456,0l2.841-1.613c.119-.07.112-.189,0-.267l-3.283-1.894a.505.505,0,0,0-.449,0l-2.841,1.641c-.119.063-.112.182,0,.26Zm-6.235-5.871-2.806,1.641c-.126.063-.119.182,0,.26l3.283,1.894a.484.484,0,0,0,.449,0l2.806-1.634c.119-.07.112-.189,0-.267l-3.276-1.894A.519.519,0,0,0,128.488,269.77Zm10.837,3.507,2.841-1.641c.119-.07.112-.182,0-.26l-3.276-1.894a.5.5,0,0,0-.456,0l-2.806,1.634c-.126.07-.119.189,0,.26l3.283,1.9a.5.5,0,0,0,.414-.021Zm4.145-2.392,2.841-1.641a.14.14,0,0,0,0-.26l-3.283-1.894a.5.5,0,0,0-.456,0l-2.806,1.641c-.119.07-.112.182,0,.26l3.283,1.894a.505.505,0,0,0,.421-.021Zm4.152-2.4,2.806-1.634c.119-.07.112-.189,0-.267l-3.283-1.894a.505.505,0,0,0-.449,0l-2.806,1.634c-.119.07-.112.189,0,.267l3.283,1.894a.519.519,0,0,0,.449-.021ZM132.633,267.4l-2.806,1.634c-.119.07-.112.189,0,.267l3.283,1.894a.5.5,0,0,0,.449,0l2.806-1.641c.119-.07.112-.182,0-.259l-3.283-1.894a.5.5,0,0,0-.449-.021Zm4.152-2.4-2.806,1.641c-.119.07-.112.182,0,.26l3.283,1.894a.519.519,0,0,0,.456,0l2.806-1.641a.14.14,0,0,0,0-.26L137.242,265a.484.484,0,0,0-.456-.021Zm16.588-9.574-2.806,1.634c-.119.07-.112.189,0,.267l3.283,1.894a.519.519,0,0,0,.456,0l2.806-1.634c.119-.07.112-.189,0-.267l-3.283-1.894a.505.505,0,0,0-.456-.021Zm-4.152,2.392-2.806,1.641c-.119.07-.112.182,0,.26l3.283,1.894a.484.484,0,0,0,.449,0l2.841-1.634a.14.14,0,0,0,0-.259l-3.283-1.894a.5.5,0,0,0-.484-.028Zm8.3-4.833-2.806,1.634a.14.14,0,0,0,0,.26l3.276,1.894a.5.5,0,0,0,.456,0l2.806-1.641c.126-.07.119-.182,0-.26l-3.283-1.894a.484.484,0,0,0-.449.007Zm-16.588,9.574-2.841,1.648c-.119.063-.112.182,0,.26l3.276,1.894a.519.519,0,0,0,.456,0l2.806-1.634c.126-.07.119-.189,0-.267l-3.283-1.894a.5.5,0,0,0-.414.021Zm4.145-2.392-2.841,1.634a.14.14,0,0,0,0,.26l3.283,1.9a.5.5,0,0,0,.449,0l2.841-1.641c.119-.07.112-.182,0-.26l-3.276-1.894a.5.5,0,0,0-.428.028Zm-3.03,16.9,2.841-1.634a.14.14,0,0,0,0-.26l-3.29-1.845a.519.519,0,0,0-.456,0l-2.806,1.641c-.119.07-.112.182,0,.26l3.283,1.894a.484.484,0,0,0,.428-.028Zm-24.3-2.427-3.283-1.894a.484.484,0,0,0-.449,0l-2.806,1.634a.14.14,0,0,0,0,.26l3.283,1.9a.519.519,0,0,0,.456,0l2.806-1.641C117.848,274.827,117.841,274.729,117.75,274.638Zm6.214,1.824-3.283-1.894a.484.484,0,0,0-.449,0l-4.37,2.518a.14.14,0,0,0,0,.26l3.276,1.894a.5.5,0,0,0,.456,0l4.363-2.525c.105-.063.105-.175-.028-.253Zm-11.222-5.485-3.283-1.894a.484.484,0,0,0-.449,0L105.5,271.1a.14.14,0,0,0,0,.259l3.283,1.894a.5.5,0,0,0,.456,0l3.507-2.02c.091-.063.091-.175-.07-.253Zm2.679-1.543a.505.505,0,0,0,.449,0l2.806-1.641c.119-.07.112-.182,0-.26l-3.283-1.894a.5.5,0,0,0-.456,0l-2.806,1.634a.14.14,0,0,0,0,.26Zm14.351,9.118-3.283-1.894a.5.5,0,0,0-.456,0l-5.457,3.149c-.119.07-.112.182,0,.26l3.283,1.894a.505.505,0,0,0,.449,0l5.457-3.156c.077-.077.07-.189-.056-.267Zm2.721,3.844L129.21,280.5a.484.484,0,0,0-.449,0l-3.507,2.02c-.119.07-.112.182,0,.259l3.283,1.894a.484.484,0,0,0,.449,0l3.507-2.013a.176.176,0,0,0-.063-.281Zm13.762-30.75a.505.505,0,0,0,.449,0L149.544,250c.119-.07.112-.182,0-.26l-3.283-1.894a.5.5,0,0,0-.456,0L143,249.485a.14.14,0,0,0,0,.26Zm-8.3,4.784a.5.5,0,0,0,.456,0l2.806-1.641c.126-.07.119-.189,0-.26l-3.283-1.894a.484.484,0,0,0-.449,0l-2.806,1.641a.14.14,0,0,0,0,.26ZM119.5,267.013a.519.519,0,0,0,.456,0l2.806-1.641a.14.14,0,0,0,0-.26l-3.283-1.894a.484.484,0,0,0-.449,0l-2.806,1.641c-.119.07-.112.182,0,.26ZM142.046,254a.484.484,0,0,0,.449,0l2.841-1.634c.119-.07.112-.189,0-.267l-3.276-1.894a.519.519,0,0,0-.456,0l-2.806,1.641c-.126.063-.119.182,0,.26Zm-8.3,4.791a.519.519,0,0,0,.456,0l2.806-1.641c.119-.07.112-.182,0-.26L133.728,255a.484.484,0,0,0-.449,0l-2.806,1.634c-.119.07-.112.189,0,.267Zm.961,23.848a.5.5,0,0,0-.456,0l-4.363,2.518c-.119.07-.112.189,0,.267l3.29,1.929a.519.519,0,0,0,.456,0L138,284.836a.14.14,0,0,0,0-.26ZM127.8,262.195a.484.484,0,0,0,.449,0l2.841-1.641c.119-.07.112-.182,0-.26l-3.276-1.894a.5.5,0,0,0-.456,0l-2.806,1.634c-.126.07-.119.189,0,.26Zm-4.152,2.4a.5.5,0,0,0,.456,0l2.806-1.634c.126-.07.119-.189,0-.267l-3.283-1.894a.505.505,0,0,0-.449,0l-2.806,1.641c-.119.063-.112.182,0,.26Zm87.886-26.317a.5.5,0,0,0-.449,0l-7.014,4.033a.14.14,0,0,0,0,.26l3.283,1.894a.5.5,0,0,0,.456,0l7.014-4.033a.14.14,0,0,0,0-.26Zm-9.167,5.3a.484.484,0,0,0-.449,0l-2.806,1.7c-.119.07-.112.189,0,.267l3.276,1.894a.519.519,0,0,0,.456,0l2.806-1.641c.119-.07.112-.182,0-.26ZM146.2,274.729,149,273.088c.119-.063.112-.182,0-.26l-3.283-1.894a.484.484,0,0,0-.449,0l-2.806,1.634c-.119.07-.112.189,0,.267l3.283,1.894A.519.519,0,0,0,146.2,274.729Zm47.878-26.289a.5.5,0,0,0-.456,0l-2.806,1.641a.14.14,0,0,0,0,.26l3.283,1.894a.5.5,0,0,0,.456,0l2.806-1.641a.14.14,0,0,0,0-.26Zm21.61-12.478a.5.5,0,0,0-.456,0l-2.806,1.634c-.126.07-.119.189,0,.267l3.283,1.894a.505.505,0,0,0,.449,0L219,238.116c.119-.07.112-.182,0-.26Zm7.428-.5-7.968-4.6a.5.5,0,0,0-.456,0l-2.806,1.634c-.126.07-.119.189,0,.26l7.968,4.6a.484.484,0,0,0,.449,0l2.841-1.641c.105-.091.1-.21-.028-.267Zm-44.532,21.919a.519.519,0,0,0-.456,0l-3.507,2.013c-.119.07-.112.189,0,.267l3.283,1.894a.519.519,0,0,0,.456,0l3.507-2.013c.119-.07.112-.189,0-.267Zm10.472-6.046a.484.484,0,0,0-.449,0l-4.37,2.518a.14.14,0,0,0,0,.26l3.276,1.894a.5.5,0,0,0,.456,0l4.363-2.525c.126-.07.112-.182,0-.26Zm-20.1,11.566a.505.505,0,0,0-.449,0l-23.357,13.488c-.119.07-.112.182,0,.26l3.276,1.894a.519.519,0,0,0,.456,0l23.35-13.488c.126-.07.119-.182,0-.26Zm-24.661,14.238a.484.484,0,0,0-.449,0l-3.507,2.013c-.126.07-.119.189,0,.259l3.283,1.894a.484.484,0,0,0,.449,0l3.507-2.02c.119-.07.112-.182,0-.26Zm29.459-17.009a.5.5,0,0,0-.456,0l-3.507,2.02c-.126.07-.119.182,0,.26l3.283,1.894a.484.484,0,0,0,.449,0l3.507-2.013a.14.14,0,0,0,0-.259Zm-34.257,19.78a.5.5,0,0,0-.449,0l-3.507,2.013c-.119.07-.112.189,0,.267l3.283,1.894a.519.519,0,0,0,.456,0l3.507-2.013c.119-.07.112-.189,0-.267Zm43.873-25.328a.484.484,0,0,0-.449,0L179.41,256.6a.14.14,0,0,0,0,.259l3.283,1.9a.505.505,0,0,0,.449,0l3.507-2.02c.119-.07.112-.182,0-.26Zm14.842-8.571a.505.505,0,0,0-.449,0l-2.855,1.634c-.119.07-.112.182,0,.26l3.283,1.894a.5.5,0,0,0,.456,0l2.806-1.634c.119-.07.112-.189,0-.267Zm9.118-6.6,2.806-1.634a.14.14,0,0,0,0-.26l-3.283-1.894a.484.484,0,0,0-.449,0l-2.806,1.641c-.119.07-.112.182,0,.26l3.283,1.894a.5.5,0,0,0,.435-.007Zm-18.545-.119,2.841-1.634a.14.14,0,0,0,0-.26l-3.283-1.894a.5.5,0,0,0-.456,0l-2.806,1.641c-.126.07-.112.182,0,.26l3.283,1.894a.484.484,0,0,0,.407-.007Zm-9.392,16.252,8.291-4.791c.119-.063.112-.182,0-.26L184.4,248.6a.505.505,0,0,0-.449,0l-8.3,4.791c-.119.063-.112.182,0,.26l3.283,1.894a.519.519,0,0,0,.442,0ZM202.725,241.8a.505.505,0,0,0,.449,0l2.806-1.641c.119-.07.112-.182,0-.26L202.7,238.01a.5.5,0,0,0-.456,0l-2.806,1.634a.14.14,0,0,0,0,.26Zm-4.208-2.7,2.806-1.641c.119-.063.112-.182,0-.26l-3.276-1.894a.519.519,0,0,0-.456,0l-2.806,1.634c-.126.07-.119.189,0,.267l3.283,1.894a.505.505,0,0,0,.407,0Zm-23.252,18.84,2.841-1.641a.14.14,0,0,0,0-.259l-3.283-1.894a.5.5,0,0,0-.456,0l-2.806,1.641c-.119.07-.112.182,0,.26l3.283,1.894a.505.505,0,0,0,.379,0Zm18.321-10.851a.5.5,0,0,0,.456,0l2.806-1.634a.14.14,0,0,0,0-.26l-3.283-1.894a.5.5,0,0,0-.456,0l-2.806,1.641c-.119.07-.112.182,0,.26ZM154.531,269.91l2.841-1.634a.14.14,0,0,0,0-.26l-3.276-1.9a.519.519,0,0,0-.456,0l-2.806,1.641c-.126.07-.119.182,0,.26l3.283,1.894a.484.484,0,0,0,.372,0Zm4.145-2.392,2.841-1.641c.119-.07.112-.182,0-.259l-3.283-1.894a.5.5,0,0,0-.456,0l-2.806,1.634c-.119.07-.112.189,0,.267l3.283,1.894a.505.505,0,0,0,.379,0Zm-8.291,4.791,2.806-1.641c.126-.07.119-.189,0-.259l-3.283-1.894a.505.505,0,0,0-.449,0l-2.806,1.641a.14.14,0,0,0,0,.259l3.276,1.894a.5.5,0,0,0,.414,0Zm16.588-9.581,2.806-1.634c.126-.07.119-.189,0-.267l-3.283-1.894a.505.505,0,0,0-.449,0l-2.806,1.641c-.119.063-.112.182,0,.259l3.276,1.894a.5.5,0,0,0,.414,0Zm-4.145,2.4,2.806-1.641a.14.14,0,0,0,0-.26l-3.283-1.894a.484.484,0,0,0-.449,0l-2.806,1.641a.14.14,0,0,0,0,.259l3.283,1.894a.5.5,0,0,0,.407,0Zm8.227-4.791,2.841-1.641c.119-.07.112-.182,0-.26l-3.276-1.894a.5.5,0,0,0-.456,0l-2.806,1.634c-.119.07-.112.189,0,.267l3.283,1.894a.505.505,0,0,0,.414,0Zm18.994-35.407a.5.5,0,0,0,.456,0l2.806-1.634a.14.14,0,0,0,0-.26l-.877-.505a.484.484,0,0,0-.449,0l-2.841,1.641a.14.14,0,0,0,0,.26Zm-20.4,13.158a.519.519,0,0,0,.456,0l2.806-1.634c.119-.07.112-.189,0-.267l-3.283-1.894a.519.519,0,0,0-.456,0l-2.806,1.634c-.119.07-.112.189,0,.267Zm8.291-4.791a.5.5,0,0,0,.456,0l2.806-1.634a.14.14,0,0,0,0-.26l-3.283-1.9a.5.5,0,0,0-.449,0l-2.806,1.641c-.119.07-.112.182,0,.26Zm-13.327,7.715a.519.519,0,0,0,.456,0l2.806-1.641c.119-.07.112-.182,0-.26l-3.283-1.894a.484.484,0,0,0-.449,0l-2.841,1.634c-.119.07-.112.189,0,.267Zm9.209-5.324a.5.5,0,0,0,.456,0l2.806-1.641c.119-.07.112-.182,0-.26l-3.283-1.894a.484.484,0,0,0-.449,0l-2.841,1.634a.14.14,0,0,0,0,.26ZM156.292,245.8a.484.484,0,0,0,.449,0l2.806-1.641a.14.14,0,0,0,0-.26L156.271,242a.519.519,0,0,0-.456,0l-2.806,1.641a.14.14,0,0,0,0,.26Zm4.145-2.392a.484.484,0,0,0,.449,0l2.841-1.634c.119-.07.112-.189,0-.267l-3.283-1.894a.519.519,0,0,0-.456,0l-2.806,1.641c-.119.07-.112.182,0,.26Zm21.323-13.7a.505.505,0,0,0,.449,0l2.806-1.634c.119-.07.112-.189,0-.267l-.87-.505a.519.519,0,0,0-.456,0l-2.806,1.641c-.119.07-.112.182,0,.26Zm12.443-7.182a.519.519,0,0,0,.456,0l2.806-1.641c.126-.063.119-.182,0-.26l-.87-.505a.519.519,0,0,0-.456,0l-2.841,1.641c-.119.063-.112.182,0,.26ZM201.1,226.5a.484.484,0,0,0,.449,0l2.806-1.634a.14.14,0,0,0,0-.26l-3.283-1.9a.519.519,0,0,0-.456,0l-2.806,1.641c-.119.07-.112.182,0,.26Zm10.367,10.521,2.806-1.634c.126-.07.119-.189,0-.267l-3.283-1.894a.505.505,0,0,0-.449,0l-2.841,1.634c-.119.07-.112.189,0,.267l3.276,1.894a.5.5,0,0,0,.484,0Zm-25.552-9.714a.484.484,0,0,0,.449,0l2.841-1.641c.119-.07.112-.182,0-.26l-.877-.505a.484.484,0,0,0-.449,0l-2.806,1.634c-.119.07-.112.189,0,.267Zm-33.794,20.888a.519.519,0,0,0,.456,0l2.806-1.641c.126-.063.119-.182,0-.26L152.1,244.4a.484.484,0,0,0-.449,0l-2.806,1.634c-.119.07-.112.189,0,.267Z",
    transform: "translate(-75.834 -109.863)",
    fill: "#fff",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67453",
    "data-name": "Path 67453",
    d: "M197.984,288.621l28-16.167a3.36,3.36,0,0,1,3.058,0l16.055,9.266a.933.933,0,0,1,0,1.768l-28,16.167a3.4,3.4,0,0,1-3.058,0l-16.055-9.273a.933.933,0,0,1,0-1.761Z",
    transform: "translate(-103.288 -125.396)",
    fill: "#102633"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67454",
    "data-name": "Path 67454",
    d: "M197.984,288.621l28-16.167a3.36,3.36,0,0,1,3.058,0l16.055,9.266a.933.933,0,0,1,0,1.768l-28,16.167a3.4,3.4,0,0,1-3.058,0l-16.055-9.273a.933.933,0,0,1,0-1.761Z",
    transform: "translate(-103.288 -125.396)",
    fill: "#fff",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67455",
    "data-name": "Path 67455",
    d: "M66.538,281.114a3.945,3.945,0,0,0,.786.33,3.262,3.262,0,0,1-.786-.33,2.291,2.291,0,0,1-.238-.154Z",
    transform: "translate(-64.154 -128.046)",
    fill: "#102633"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67456",
    "data-name": "Path 67456",
    d: "M171.035,67.481c-.182-1.319-1.234-1.8-2.518-1.059L70.882,122.793a5.211,5.211,0,0,0-1.8,1.894L64.31,121.9a5.085,5.085,0,0,1,1.8-1.894l97.635-56.323a4.756,4.756,0,0,1,7.295,3.816Z",
    transform: "translate(-63.559 -62.949)",
    fill: "#fff",
    opacity: 0.85
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67457",
    "data-name": "Path 67457",
    d: "M73,281.52h.042Z",
    transform: "translate(-66.154 -128.214)",
    fill: "#102633"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67458",
    "data-name": "Path 67458",
    d: "M281.767,263.7a5.436,5.436,0,0,1-2.546,4.208l-97.635,56.365a5.156,5.156,0,0,1-2.546.6v-5.506a5.162,5.162,0,0,0,2.546-.61L279.221,262.4c1.312-.764,1.4-1.957.26-2.806a5.492,5.492,0,0,1,2.287,4.11Z",
    transform: "translate(-97.818 -121.665)",
    fill: "#fff",
    opacity: 0.7
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Code--inject-209",
    transform: "translate(13.544 25.914)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_67459",
    "data-name": "Path 67459",
    d: "M82.659,159.663a.533.533,0,0,1,.07-.26l1.01-2.1a.21.21,0,0,1,.049-.056h0a.056.056,0,0,1,.077,0,.14.14,0,0,1,0,.1v.7a.911.911,0,0,1,0,.217,1.13,1.13,0,0,1-.07.2l-.54,1.108.54.491a.308.308,0,0,1,.07.105.659.659,0,0,1,0,.2v.7a.372.372,0,0,1,0,.14.231.231,0,0,1-.077.1h0a.042.042,0,0,1-.049,0l-1.01-.926a.21.21,0,0,1-.07-.182Z",
    transform: "translate(-82.582 -117.014)",
    fill: "#102633"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67460",
    "data-name": "Path 67460",
    d: "M87.255,152.942a.848.848,0,0,1,.077-.21.407.407,0,0,1,.147-.161l.379-.217a.063.063,0,0,1,.084,0,.14.14,0,0,1,0,.1.315.315,0,0,1,0,.077l-1.754,7.428a.962.962,0,0,1-.07.2.365.365,0,0,1-.154.168l-.365.21h-.084a.147.147,0,0,1,0-.105.364.364,0,0,1,0-.077Z",
    transform: "translate(-83.433 -115.554)",
    fill: "#102633"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67461",
    "data-name": "Path 67461",
    d: "M91.269,155.481a.547.547,0,0,1-.077.26l-1.01,2.1-.049.063h0a.056.056,0,0,1-.077,0,.147.147,0,0,1,0-.105v-.7a.912.912,0,0,1,0-.217,1.64,1.64,0,0,1,.07-.189l.54-1.108-.54-.5a.28.28,0,0,1-.07-.105.66.66,0,0,1,0-.2v-.7a.379.379,0,0,1,0-.147.281.281,0,0,1,.077-.1h.049l1.01.933a.2.2,0,0,1,.077.175Z",
    transform: "translate(-84.788 -116.003)",
    fill: "#102633"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67462",
    "data-name": "Path 67462",
    d: "M95.562,155.473a.084.084,0,0,1,.1,0,.168.168,0,0,1,.042.126v.779a.379.379,0,0,1-.007.161.287.287,0,0,1-.1.119l-.477.281a.084.084,0,0,1-.1,0,.175.175,0,0,1-.042-.133v-.772a.379.379,0,0,1,.042-.175.21.21,0,0,1,.1-.119Z",
    transform: "translate(-86.261 -116.486)",
    fill: "#102633"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67463",
    "data-name": "Path 67463",
    d: "M97.827,154.161a.07.07,0,0,1,.1,0,.154.154,0,0,1,.042.126v.772a.379.379,0,0,1-.042.175.245.245,0,0,1-.1.119l-.477.281h-.1a.168.168,0,0,1-.042-.126v-.765a.4.4,0,0,1,.042-.175.245.245,0,0,1,.1-.119Z",
    transform: "translate(-86.927 -116.093)",
    fill: "#102633"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67464",
    "data-name": "Path 67464",
    d: "M100.107,152.85h.1a.168.168,0,0,1,.042.126v.779a.372.372,0,0,1-.042.168.267.267,0,0,1-.1.126l-.477.274a.077.077,0,0,1-.1,0,.168.168,0,0,1-.042-.126v-.779a.428.428,0,0,1,.042-.175.288.288,0,0,1,.1-.119Z",
    transform: "translate(-87.608 -115.707)",
    fill: "#102633"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67465",
    "data-name": "Path 67465",
    d: "M83.048,163.9l19.7-11.391c.274-.161.5-.049.5.253a1.073,1.073,0,0,1-.5.828l-19.7,11.4c-.274.161-.5.042-.5-.252A1.087,1.087,0,0,1,83.048,163.9Z",
    transform: "translate(-82.55 -115.583)",
    fill: "#102633"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67466",
    "data-name": "Path 67466",
    d: "M93.785,162.492l75.871-43.8c.281-.161.505-.042.505.253a1.073,1.073,0,0,1-.505.835l-75.871,43.8c-.281.161-.505.049-.505-.253a1.073,1.073,0,0,1,.505-.835Z",
    transform: "translate(-85.754 -105.485)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67467",
    "data-name": "Path 67467",
    d: "M93.785,185.5l7.463-4.328c.274-.161.5-.049.5.253a1.059,1.059,0,0,1-.5.828l-7.463,4.328c-.281.161-.505.049-.505-.253A1.059,1.059,0,0,1,93.785,185.5Z",
    transform: "translate(-85.754 -124.141)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67468",
    "data-name": "Path 67468",
    d: "M93.785,191.687l7.463-4.328c.274-.161.5-.042.5.253a1.087,1.087,0,0,1-.5.835l-7.463,4.328c-.281.161-.505.049-.505-.253a1.073,1.073,0,0,1,.505-.835Z",
    transform: "translate(-85.754 -125.99)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67469",
    "data-name": "Path 67469",
    d: "M113.905,135.691l61.78-35.722c.281-.161.505-.049.505.253a1.073,1.073,0,0,1-.505.835l-61.78,35.715c-.281.161-.505.049-.505-.253a1.073,1.073,0,0,1,.505-.828Z",
    transform: "translate(-91.762 -99.895)",
    fill: "#102633"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67470",
    "data-name": "Path 67470",
    d: "M94.015,227.564l12.008-6.916c.274-.161.5-.049.5.252a1.087,1.087,0,0,1-.5.835l-12.008,6.916c-.281.161-.505.049-.505-.252A1.073,1.073,0,0,1,94.015,227.564Z",
    transform: "translate(-85.823 -135.93)",
    fill: "#102633"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67471",
    "data-name": "Path 67471",
    d: "M113.905,203.842l61.78-35.722c.281-.161.505-.042.505.253a1.073,1.073,0,0,1-.505.835l-61.78,35.722c-.281.161-.505.042-.505-.252A1.073,1.073,0,0,1,113.905,203.842Z",
    transform: "translate(-91.762 -120.245)",
    fill: "#102633"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67472",
    "data-name": "Path 67472",
    d: "M113.905,197.5l61.78-35.722c.281-.161.505-.049.505.252a1.073,1.073,0,0,1-.505.835l-61.78,35.715c-.281.161-.505.049-.505-.253A1.052,1.052,0,0,1,113.905,197.5Z",
    transform: "translate(-91.762 -118.351)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67473",
    "data-name": "Path 67473",
    d: "M113.905,185.291l61.78-35.722c.281-.161.505-.049.505.253a1.073,1.073,0,0,1-.505.835l-61.78,35.722c-.281.154-.505.042-.505-.26a1.059,1.059,0,0,1,.505-.828Z",
    transform: "translate(-91.762 -114.705)",
    fill: "#102633"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67474",
    "data-name": "Path 67474",
    d: "M113.905,191.482l61.78-35.722c.281-.161.505-.042.505.253a1.073,1.073,0,0,1-.505.835l-61.78,35.722c-.281.161-.505.049-.505-.253a1.073,1.073,0,0,1,.505-.835Z",
    transform: "translate(-91.762 -116.554)",
    fill: "#102633"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67475",
    "data-name": "Path 67475",
    d: "M94.015,221.374l12.008-6.916c.274-.161.5-.049.5.253a1.087,1.087,0,0,1-.5.835l-12.008,6.916c-.281.161-.505.049-.505-.252a1.073,1.073,0,0,1,.505-.835Z",
    transform: "translate(-85.823 -134.081)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67476",
    "data-name": "Path 67476",
    d: "M104.788,204.9l3.7-2.181c.281-.161.505-.049.505.253a1.059,1.059,0,0,1-.5.828l-3.7,2.188c-.274.154-.5.042-.5-.26a1.08,1.08,0,0,1,.5-.828Z",
    transform: "translate(-89.041 -130.576)",
    fill: "#102633"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67477",
    "data-name": "Path 67477",
    d: "M104.788,198.73l3.7-2.181c.281-.161.505-.049.505.252a1.073,1.073,0,0,1-.505.835l-3.7,2.181c-.274.161-.5.049-.5-.253a1.087,1.087,0,0,1,.5-.835Z",
    transform: "translate(-89.041 -128.733)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67478",
    "data-name": "Path 67478",
    d: "M104.788,211.039l3.7-2.188c.281-.154.505-.042.505.259a1.073,1.073,0,0,1-.505.828l-3.7,2.181c-.274.154-.5.042-.5-.26a1.073,1.073,0,0,1,.5-.821Z",
    transform: "translate(-89.041 -132.408)",
    fill: "#102633"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67479",
    "data-name": "Path 67479",
    d: "M83.048,172.519l9.925-5.759c.274-.154.5-.042.5.26a1.08,1.08,0,0,1-.5.828l-9.925,5.759c-.274.161-.5.042-.5-.252A1.087,1.087,0,0,1,83.048,172.519Z",
    transform: "translate(-82.55 -119.84)",
    fill: "#102633"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67480",
    "data-name": "Path 67480",
    d: "M83.048,172.519l9.925-5.759c.274-.154.5-.042.5.26a1.08,1.08,0,0,1-.5.828l-9.925,5.759c-.274.161-.5.042-.5-.252A1.087,1.087,0,0,1,83.048,172.519Z",
    transform: "translate(-82.55 -119.84)",
    fill: "#fff",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67481",
    "data-name": "Path 67481",
    d: "M83.048,180l4.643-2.679c.281-.161.505-.049.505.252a1.073,1.073,0,0,1-.505.835l-4.643,2.679c-.274.161-.5.049-.5-.253a1.087,1.087,0,0,1,.5-.835Z",
    transform: "translate(-82.55 -122.991)",
    fill: "#102633"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67482",
    "data-name": "Path 67482",
    d: "M83.048,180l4.643-2.679c.281-.161.505-.049.505.252a1.073,1.073,0,0,1-.505.835l-4.643,2.679c-.274.161-.5.049-.5-.253a1.087,1.087,0,0,1,.5-.835Z",
    transform: "translate(-82.55 -122.991)",
    fill: "#fff",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67483",
    "data-name": "Path 67483",
    d: "M83.048,186.2l4.643-2.686c.281-.161.505-.042.505.253a1.073,1.073,0,0,1-.505.835l-4.643,2.686c-.274.154-.5.042-.5-.253A1.087,1.087,0,0,1,83.048,186.2Z",
    transform: "translate(-82.55 -124.84)",
    fill: "#102633"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67484",
    "data-name": "Path 67484",
    d: "M83.048,186.2l4.643-2.686c.281-.161.505-.042.505.253a1.073,1.073,0,0,1-.505.835l-4.643,2.686c-.274.154-.5.042-.5-.253A1.087,1.087,0,0,1,83.048,186.2Z",
    transform: "translate(-82.55 -124.84)",
    fill: "#fff",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67485",
    "data-name": "Path 67485",
    d: "M83.048,192.388l4.643-2.679c.281-.161.505-.049.505.253a1.073,1.073,0,0,1-.505.835l-4.643,2.679c-.274.161-.5.049-.5-.253A1.087,1.087,0,0,1,83.048,192.388Z",
    transform: "translate(-82.55 -126.691)",
    fill: "#102633"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67486",
    "data-name": "Path 67486",
    d: "M83.048,192.388l4.643-2.679c.281-.161.505-.049.505.253a1.073,1.073,0,0,1-.505.835l-4.643,2.679c-.274.161-.5.049-.5-.253A1.087,1.087,0,0,1,83.048,192.388Z",
    transform: "translate(-82.55 -126.691)",
    fill: "#fff",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67487",
    "data-name": "Path 67487",
    d: "M83.048,198.586l4.643-2.686c.281-.161.505-.042.505.253a1.073,1.073,0,0,1-.505.835l-4.643,2.686c-.274.161-.5.042-.5-.253a1.087,1.087,0,0,1,.5-.835Z",
    transform: "translate(-82.55 -128.54)",
    fill: "#102633"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67488",
    "data-name": "Path 67488",
    d: "M83.048,198.586l4.643-2.686c.281-.161.505-.042.505.253a1.073,1.073,0,0,1-.505.835l-4.643,2.686c-.274.161-.5.042-.5-.253a1.087,1.087,0,0,1,.5-.835Z",
    transform: "translate(-82.55 -128.54)",
    fill: "#fff",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67489",
    "data-name": "Path 67489",
    d: "M99.968,163.691l5.948-3.423c.281-.161.505-.049.505.253a1.073,1.073,0,0,1-.505.835l-5.948,3.423c-.274.161-.5.049-.5-.253A1.087,1.087,0,0,1,99.968,163.691Z",
    transform: "translate(-87.602 -117.9)",
    fill: "#102633"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67490",
    "data-name": "Path 67490",
    d: "M99.968,163.691l5.948-3.423c.281-.161.505-.049.505.253a1.073,1.073,0,0,1-.505.835l-5.948,3.423c-.274.161-.5.049-.5-.253A1.087,1.087,0,0,1,99.968,163.691Z",
    transform: "translate(-87.602 -117.9)",
    fill: "#fff",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67491",
    "data-name": "Path 67491",
    d: "M113.085,179.438l62.355-36.059c.281-.161.505-.042.505.253a1.073,1.073,0,0,1-.505.835l-62.355,36.059c-.281.161-.505.049-.505-.253a1.073,1.073,0,0,1,.505-.835Z",
    transform: "translate(-91.517 -112.858)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67492",
    "data-name": "Path 67492",
    d: "M167.008,151.347l24.549-14.168c.281-.161.505-.049.505.253a1.073,1.073,0,0,1-.505.835l-24.549,14.168c-.274.161-.5.042-.5-.253a1.087,1.087,0,0,1,.5-.835Z",
    transform: "translate(-107.62 -111.006)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67493",
    "data-name": "Path 67493",
    d: "M101.788,184.289l43.8-25.321c.281-.161.505-.049.505.253a1.073,1.073,0,0,1-.505.835l-43.8,25.321c-.274.161-.5.049-.5-.253a1.087,1.087,0,0,1,.5-.835Z",
    transform: "translate(-88.146 -117.512)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67494",
    "data-name": "Path 67494",
    d: "M93.785,172.518l9.925-5.759c.274-.161.505-.042.505.253a1.094,1.094,0,0,1-.505.835l-9.925,5.745c-.281.154-.505.042-.505-.26a1.08,1.08,0,0,1,.505-.814Z",
    transform: "translate(-85.754 -119.839)",
    fill: "#102633"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67495",
    "data-name": "Path 67495",
    d: "M93.785,172.518l9.925-5.759c.274-.161.505-.042.505.253a1.094,1.094,0,0,1-.505.835l-9.925,5.745c-.281.154-.505.042-.505-.26a1.08,1.08,0,0,1,.505-.814Z",
    transform: "translate(-85.754 -119.839)",
    fill: "#fff",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67496",
    "data-name": "Path 67496",
    d: "M110.7,149.394l64.038-36.985c.274-.161.5-.049.5.253a1.059,1.059,0,0,1-.5.828L110.7,150.481c-.274.161-.5.049-.5-.253a1.087,1.087,0,0,1,.5-.835Z",
    transform: "translate(-90.806 -103.61)",
    fill: "#102633"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67497",
    "data-name": "Path 67497",
    d: "M110.7,149.394l64.038-36.985c.274-.161.5-.049.5.253a1.059,1.059,0,0,1-.5.828L110.7,150.481c-.274.161-.5.049-.5-.253a1.087,1.087,0,0,1,.5-.835Z",
    transform: "translate(-90.806 -103.61)",
    fill: "#fff",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67498",
    "data-name": "Path 67498",
    d: "M83.048,238.837l19.7-11.4c.274-.161.5-.042.5.253a1.087,1.087,0,0,1-.5.835l-19.7,11.4c-.274.154-.5.042-.5-.26a1.073,1.073,0,0,1,.5-.828Z",
    transform: "translate(-82.55 -137.958)",
    fill: "#102633"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67499",
    "data-name": "Path 67499",
    d: "M113.905,210.633l61.78-35.722c.281-.154.505-.042.505.26a1.059,1.059,0,0,1-.505.828l-61.78,35.722c-.281.161-.505.049-.505-.252a1.073,1.073,0,0,1,.505-.835Z",
    transform: "translate(-91.762 -122.274)",
    fill: "#102633"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67500",
    "data-name": "Path 67500",
    d: "M83.048,247.447l9.925-5.759c.274-.161.5-.049.5.253a1.087,1.087,0,0,1-.5.835l-9.925,5.759c-.274.154-.5.042-.5-.26a1.073,1.073,0,0,1,.5-.828Z",
    transform: "translate(-82.55 -142.212)",
    fill: "#102633"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67501",
    "data-name": "Path 67501",
    d: "M83.048,247.447l9.925-5.759c.274-.161.5-.049.5.253a1.087,1.087,0,0,1-.5.835l-9.925,5.759c-.274.154-.5.042-.5-.26a1.073,1.073,0,0,1,.5-.828Z",
    transform: "translate(-82.55 -142.212)",
    fill: "#fff",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67502",
    "data-name": "Path 67502",
    d: "M83.048,254.937l4.643-2.686c.281-.154.505-.042.505.26a1.059,1.059,0,0,1-.505.828l-4.643,2.686c-.274.161-.5.049-.5-.253a1.087,1.087,0,0,1,.5-.835Z",
    transform: "translate(-82.55 -145.367)",
    fill: "#102633"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67503",
    "data-name": "Path 67503",
    d: "M83.048,254.937l4.643-2.686c.281-.154.505-.042.505.26a1.059,1.059,0,0,1-.505.828l-4.643,2.686c-.274.161-.5.049-.5-.253a1.087,1.087,0,0,1,.5-.835Z",
    transform: "translate(-82.55 -145.367)",
    fill: "#fff",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67504",
    "data-name": "Path 67504",
    d: "M99.968,238.631l5.948-3.423c.281-.161.505-.049.505.253a1.073,1.073,0,0,1-.505.835l-5.948,3.423c-.274.161-.5.049-.5-.253a1.087,1.087,0,0,1,.5-.835Z",
    transform: "translate(-87.602 -140.277)",
    fill: "#102633"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67505",
    "data-name": "Path 67505",
    d: "M99.968,238.631l5.948-3.423c.281-.161.505-.049.505.253a1.073,1.073,0,0,1-.505.835l-5.948,3.423c-.274.161-.5.049-.5-.253a1.087,1.087,0,0,1,.5-.835Z",
    transform: "translate(-87.602 -140.277)",
    fill: "#fff",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67506",
    "data-name": "Path 67506",
    d: "M93.785,247.437l9.925-5.759c.274-.161.505-.049.505.253a1.094,1.094,0,0,1-.505.835l-9.925,5.752c-.281.161-.505.049-.505-.253a1.059,1.059,0,0,1,.505-.828Z",
    transform: "translate(-85.754 -142.209)",
    fill: "#102633"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67507",
    "data-name": "Path 67507",
    d: "M93.785,247.437l9.925-5.759c.274-.161.505-.049.505.253a1.094,1.094,0,0,1-.505.835l-9.925,5.752c-.281.161-.505.049-.505-.253a1.059,1.059,0,0,1,.505-.828Z",
    transform: "translate(-85.754 -142.209)",
    fill: "#fff",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67508",
    "data-name": "Path 67508",
    d: "M110.7,224.343l64.031-36.964c.281-.161.505-.042.505.253a1.073,1.073,0,0,1-.505.835L110.7,225.43c-.274.161-.5.042-.5-.253A1.087,1.087,0,0,1,110.7,224.343Z",
    transform: "translate(-90.806 -125.996)",
    fill: "#102633"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67509",
    "data-name": "Path 67509",
    d: "M110.7,224.343l64.031-36.964c.281-.161.505-.042.505.253a1.073,1.073,0,0,1-.505.835L110.7,225.43c-.274.161-.5.042-.5-.253A1.087,1.087,0,0,1,110.7,224.343Z",
    transform: "translate(-90.806 -125.996)",
    fill: "#fff",
    opacity: 0.6
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-209",
    transform: "translate(224.368 173.842)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speach-bubble--inject-209"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speach-bubble--inject-209-2",
    "data-name": "freepik--speach-bubble--inject-209"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_67510",
    "data-name": "Path 67510",
    d: "M353.226,281.527l-3.339-4.163,2.686-5.088V269.15l-8.213,3.127V275.4l3.507,4.033a.5.5,0,0,0,.246.139h0Z",
    transform: "translate(-322.89 -227.106)",
    fill: "#102633"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67511",
    "data-name": "Path 67511",
    d: "M353.226,281.527l-3.339-4.163,2.686-5.088V269.15l-8.213,3.127V275.4l3.507,4.033a.5.5,0,0,0,.246.139h0Z",
    transform: "translate(-322.89 -227.106)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67512",
    "data-name": "Path 67512",
    d: "M351.79,283.49l3.472,3.964a.621.621,0,0,0,.5.174.524.524,0,0,0,.444-.234l3.668-6.984Z",
    transform: "translate(-325.109 -233.158)",
    fill: "#102633"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67513",
    "data-name": "Path 67513",
    d: "M386.556,181.2a2.72,2.72,0,0,0-1.838-2.1l-1.494-.569a5.982,5.982,0,0,0-3.668,0l-63.975,24.356a2.722,2.722,0,0,0-1.831,2.1v28.435a2.722,2.722,0,0,0,1.831,2.1l1.494.569a5.982,5.982,0,0,0,3.668,0l15.627-5.962,6.032-2.313,42.288-16.1a2.713,2.713,0,0,0,1.838-2.1Z",
    transform: "translate(-313.75 -178.247)",
    fill: "#102633"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67514",
    "data-name": "Path 67514",
    d: "M313.75,263.114a2.722,2.722,0,0,0,1.831,2.1l1.494.569a6.08,6.08,0,0,0,3.36.1c-.863.213-1.522-.106-1.522-.8V236.644a1.921,1.921,0,0,1,.533-1.189l-5.162-1.966a1.921,1.921,0,0,0-.533,1.189Z",
    transform: "translate(-313.75 -207.939)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67515",
    "data-name": "Path 67515",
    d: "M386.722,180.862c-.21-.513-.926-.675-1.768-.356l-63.982,24.361a3.121,3.121,0,0,0-1.291.925l-5.162-1.966a3.22,3.22,0,0,1,1.291-.925l63.968-24.356a6,6,0,0,1,3.675,0l1.5.569a2.9,2.9,0,0,1,1.768,1.748Z",
    transform: "translate(-313.98 -178.252)",
    fill: "#fff",
    opacity: 0.5
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_67516",
    "data-name": "Path 67516",
    d: "M329.872,238.33l53.349-20.309c1.585-.606,2.862-.176,2.862.953a4.186,4.186,0,0,1-2.862,3.136l-53.349,20.309c-1.578.6-2.862.176-2.862-.953A4.2,4.2,0,0,1,329.872,238.33Z",
    transform: "translate(-317.709 -199.477)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67517",
    "data-name": "Path 67517",
    d: "M385.593,219.648a3.6,3.6,0,0,1-2.42,2.632l-10.9,4.163L329.8,242.588a2.507,2.507,0,0,1-.9.194.572.572,0,0,1-.645-.643,3.606,3.606,0,0,1,2.427-2.632l41.579-15.827,11.777-4.486a2.649,2.649,0,0,1,.9-.194A.579.579,0,0,1,385.593,219.648Z",
    transform: "translate(-318.083 -200.151)",
    fill: "#102633"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67518",
    "data-name": "Path 67518",
    d: "M385.593,219.648a3.6,3.6,0,0,1-2.42,2.632l-10.9,4.163L329.8,242.588a2.507,2.507,0,0,1-.9.194.572.572,0,0,1-.645-.643,3.606,3.606,0,0,1,2.427-2.632l41.579-15.827,11.777-4.486a2.649,2.649,0,0,1,.9-.194A.579.579,0,0,1,385.593,219.648Z",
    transform: "translate(-318.083 -200.151)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67519",
    "data-name": "Path 67519",
    d: "M342.884,253.29l-12.2,4.625a3.605,3.605,0,0,0-2.427,2.632.571.571,0,0,0,.645.643,2.507,2.507,0,0,0,.9-.194l13.081-4.977Z",
    transform: "translate(-318.083 -218.582)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67520",
    "data-name": "Path 67520",
    d: "M349.12,249.5l14.786-5.633V241.12l-14.786,5.629Z",
    transform: "translate(-324.311 -212.04)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67541",
    "data-name": "Path 67541",
    d: "M365.81,237.2l14.589-5.55V234.4l-14.589,5.555Z",
    transform: "translate(-329.295 -206.95)",
    fill: "#e6e6e6"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Gears--inject-209",
    transform: "translate(172.324 64.815)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--gears--inject-209-2",
    "data-name": "freepik--gears--inject-209"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_67542",
    "data-name": "Path 67542",
    d: "M356.692,105.955l-1.031-6-5.359,3.507a7.435,7.435,0,0,0-2.034-2.476l2.56-6.93L346.058,93l-3.507,6.719a12.807,12.807,0,0,0-3.675,1.192l-1.522-5.064-5.759,4.5.372,5.969a32.054,32.054,0,0,0-3.163,4.208l-4.72-.238-3.29,7.4,4.054,1.725a24.388,24.388,0,0,0-.8,4.706l-5.148,4.734,1.031,6,5.359-3.507a7.386,7.386,0,0,0,2.041,2.476l-2.567,6.937,4.777,1.066,5.043-4.91c1.164-.182.884-2.378,2.153-3l1.529,5.064,5.716-4.489-.147-2.35c1.157-1.291,5.52-4.131,6.467-5.611l1.185-1.957,3.311-7.421-1.543-2.806-1.711-3.633Zm-17.458,19.794c-4.384,3.444-5.723,4.208-6.516-.407s1.775-11.629,6.158-15.08,6.067-3.7,6.86.9S343.617,122.3,339.234,125.749Z",
    transform: "translate(-263.244 -73.789)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67543",
    "data-name": "Path 67543",
    d: "M356.118,93.01l6.242,3.6-3.528,6.719-6.242-3.6Z",
    transform: "translate(-273.303 -73.792)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67544",
    "data-name": "Path 67544",
    d: "M375.271,106.518l-5.359,3.528-6.242-3.605,5.359-3.521Z",
    transform: "translate(-276.612 -76.751)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67545",
    "data-name": "Path 67545",
    d: "M374.6,130.261l-4.061-1.725L364.3,124.93l4.054,1.732Z",
    transform: "translate(-276.8 -83.323)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67546",
    "data-name": "Path 67546",
    d: "M327.26,158.117l6.242,3.6,2.567-6.937-6.242-3.6Z",
    transform: "translate(-265.74 -91.161)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67547",
    "data-name": "Path 67547",
    d: "M352.1,159.969l-6.242-3.605L344.33,151.3l6.242,3.605Z",
    transform: "translate(-270.837 -91.197)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67548",
    "data-name": "Path 67548",
    d: "M365.608,111.086l-1.038-6-5.359,3.507a7.288,7.288,0,0,0-2.034-2.476l2.567-6.937-4.777-1.066-3.507,6.719a12.864,12.864,0,0,0-3.668,1.2l-1.529-5.064-5.716,4.489.372,5.969a31.849,31.849,0,0,0-3.156,4.208l-4.727-.231-3.311,7.421,4.061,1.732a23.735,23.735,0,0,0-.807,4.7l-5.148,4.741,1.038,6,5.352-3.507a7.358,7.358,0,0,0,2.041,2.469l-2.567,6.937,4.777,1.066,3.507-6.719a12.836,12.836,0,0,0,3.668-1.192l1.529,5.064,5.716-4.5-.372-5.969a32,32,0,0,0,3.156-4.208l4.727.238,3.318-7.421-4.061-1.725a23.892,23.892,0,0,0,.807-4.706Zm-17.465,19.787c-4.384,3.451-8.585,2.511-9.378-2.1s2.1-11.131,6.509-14.582,8.585-2.511,9.378,2.1S352.5,127.429,348.143,130.873Z",
    transform: "translate(-265.91 -75.314)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67549",
    "data-name": "Path 67549",
    d: "M348.989,100.675l-6.242-3.605-5.716,4.5,6.242,3.6Z",
    transform: "translate(-268.657 -75.004)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67550",
    "data-name": "Path 67550",
    d: "M337.03,103.48l.372,5.969,6.242,3.605-.372-5.976Z",
    transform: "translate(-268.657 -76.918)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67551",
    "data-name": "Path 67551",
    d: "M337.29,121.447l-6.25-3.605-4.72-.231,6.242,3.605Z",
    transform: "translate(-265.459 -81.137)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67552",
    "data-name": "Path 67552",
    d: "M324.911,117.61l-3.311,7.428,6.242,3.6,3.311-7.421Z",
    transform: "translate(-264.05 -81.137)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67553",
    "data-name": "Path 67553",
    d: "M330.291,140.968l-6.242-3.6L318.9,142.1l6.242,3.6Z",
    transform: "translate(-263.244 -87.037)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67554",
    "data-name": "Path 67554",
    d: "M326.181,153.722l-6.25-3.6-1.031-6,6.242,3.6Z",
    transform: "translate(-263.244 -89.053)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67555",
    "data-name": "Path 67555",
    d: "M363.862,96.608l-6.242-3.6,4.77,1.066,6.25,3.6Z",
    transform: "translate(-274.805 -73.792)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67556",
    "data-name": "Path 67556",
    d: "M289.5,87.844V78.881L282.364,82.1a12.625,12.625,0,0,0-1.929-4.251l4.5-9.069-5.492-3.17-5.611,8.417a12.626,12.626,0,0,0-4.643.456l-.772-7.779-7.765,4.482-.786,8.725a38.183,38.183,0,0,0-4.643,4.91l-5.611-1.957-5.492,9.511,4.5,3.879a38.123,38.123,0,0,0-1.922,6.467l-7.14,5.029v8.964l7.14-3.212a12.625,12.625,0,0,0,1.922,4.208l-4.5,9.069,5.492,3.17,5.611-8.417a12.737,12.737,0,0,0,4.643-.449l.786,7.786,7.765-4.482.779-8.7a14.554,14.554,0,0,0,6.228-4.363l4.019,1.4,5.492-9.511-3.367-2.9a20.158,20.158,0,0,0,.8-7.442Zm-24.97,22.4c-5.955,3.437-9.658,1-9.658-5.885s4.91-15.3,10.879-18.748,9.567-.933,9.567,5.948S270.489,106.8,264.527,110.24Z",
    transform: "translate(-239.55 -65.61)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67557",
    "data-name": "Path 67557",
    d: "M300.277,69.215l-6.242-3.605-5.6,8.431,6.25,3.6Z",
    transform: "translate(-254.145 -65.61)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67558",
    "data-name": "Path 67558",
    d: "M313.973,88.128l-6.249-3.6-7.133,3.212,6.242,3.605Z",
    transform: "translate(-257.776 -71.259)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67559",
    "data-name": "Path 67559",
    d: "M275.538,156.064l-6.242-3.6-.786-7.786,6.25,3.6Z",
    transform: "translate(-248.197 -89.22)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67560",
    "data-name": "Path 67560",
    d: "M246.07,148.959l6.249,3.6,4.5-9.062-6.243-3.605Z",
    transform: "translate(-241.497 -87.79)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67561",
    "data-name": "Path 67561",
    d: "M298.416,92.984V84.014l-7.14,3.219a12.675,12.675,0,0,0-1.929-4.251l4.5-9.062-5.485-3.17-5.611,8.417a12.751,12.751,0,0,0-4.643.456l-.786-7.786-7.758,4.489-.786,8.69a38.174,38.174,0,0,0-4.636,4.91l-5.611-1.957-5.471,9.511,4.5,3.872a38.226,38.226,0,0,0-1.929,6.474l-7.133,5.022v8.971l7.119-3.2a12.674,12.674,0,0,0,1.929,4.25l-4.482,9.076,5.492,3.17,5.611-8.417a12.73,12.73,0,0,0,4.636-.456l.786,7.786,7.765-4.482.786-8.69a38.721,38.721,0,0,0,4.643-4.91l5.611,1.957,5.485-9.511-4.5-3.872a38.225,38.225,0,0,0,1.929-6.474Zm-24.97,22.389c-5.962,3.437-10.788.652-10.788-6.228s4.826-15.249,10.788-18.685,10.788-.652,10.788,6.228S279.4,111.936,273.446,115.373Z",
    transform: "translate(-242.219 -67.145)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67562",
    "data-name": "Path 67562",
    d: "M259.5,92.117l6.249,3.605-5.6-1.957L253.9,90.16Z",
    transform: "translate(-243.835 -72.941)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16614",
    "data-name": "Rectangle 16614",
    width: 10.984,
    height: 7.21,
    transform: "translate(4.577 26.728) rotate(-60.03)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67563",
    "data-name": "Path 67563",
    d: "M246.07,103.72l6.249,3.605,4.5,3.872-6.243-3.6Z",
    transform: "translate(-241.497 -76.99)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67564",
    "data-name": "Path 67564",
    d: "M246.7,118.47l6.243,3.605L245.81,127.1l-6.25-3.6Z",
    transform: "translate(-239.553 -81.394)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67565",
    "data-name": "Path 67565",
    d: "M239.56,125.64l6.25,3.6v8.971l-6.25-3.605Z",
    transform: "translate(-239.553 -83.535)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67566",
    "data-name": "Path 67566",
    d: "M283.637,70.775l-6.242-3.605-7.765,4.482,6.242,3.605Z",
    transform: "translate(-248.532 -66.076)",
    fill: "#f5f5f5"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaceholder);
export default __webpack_public_path__ + "static/media/placeholder.bc160d864149296060e3decda8b6bba5.svg";
export { ForwardRef as ReactComponent };